import {
  Box,
  Paper, Typography, useTheme,
  Checkbox as MuiCheckBox,
  FormControl,
  Select,
  MenuItem,
  FormControlLabel,
  RadioGroup as MuiRadioGroup,
  InputLabel,
  FormLabel,
  Radio,
  Tooltip,
  Button,
  Icon,
  Autocomplete,
  CircularProgress,
  TextField,
  Checkbox,
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import { ptBR } from '@mui/x-data-grid/locales';
import clsx from 'clsx';
import React, { useEffect, useState, useRef, useMemo } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAppThemeContext, useAuthContext } from "../../shered/contexts";
import { FerramentasDaListagem } from "../../shered/components";
import { useDebounce } from "../../shered/hooks";
import { LayoutBaseDePagina } from "../../shered/layouts";
import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";
import CookieService from "../../shered/services/autenticacao/CookieService";
import { enumLstStats, IDadosStats, ILstDrop, lstPosicaoAmericano, lstReferenciasPosicao, porcentagemStats, quantidadeDeJogos, TDropOptions, UtilidadeService } from "../../shered/services/api/utilidades/UtilidadesService";
import { IDadosMetodo, IListagemLigas, LigaService } from "../../shered/services/api/liga/LigaService";
import { DialogEvent, IDadosModalEvento } from "../../shered/components/modal/DialogEvent";
import FileSaver from "file-saver";
import XLSX from "sheetjs-style"
import { EstatisticasService, IDadosFiltrosJogadores, IListaDadosMediaJogadores } from "../../shered/services/api/estatisticas/EstatisticasService";
import { Loading } from "../../shered/components/loading/Loading";
import { DataGrid, GridCellParams, GridColDef, GridSaveAltIcon } from "@mui/x-data-grid";
import { LoadingButton } from "@mui/lab";
import { JogadorService } from "../../shered/services/api/jogador/JogadorService";
import { FranquiaService } from "../../shered/services/api/franquia/FranquiaService";
import "../../styles.css";

const tiposFiltro = [
  {
    codigo: 1,
    label: "NBA"
  },
  {
    codigo: 2,
    label: "Liga"
  },

];

export const ListagemDeMediaJogadores: React.FC = () => {
  const theme = useTheme();
  const { themeName } = useAppThemeContext();
  const refTab = useRef<any>(null);
  const { debounce } = useDebounce();
  const [isLoading, setIsLoading] = useState(true);
  const [removeLoading, setRemoveLoading] = useState(false);
  const navigate = useNavigate();
  const { logout } = useAuthContext();
  const user = CookieService.get("access_user");
  let codLocal = localStorage.getItem("@codigoLiga");
  const [codigoLiga, setCodigoLiga] = useState(codLocal !== null ? UtilidadeService.decrypt(codLocal) : "0");
  const [showImagemFranquia, setShowImagemFranquia] = useState<any>("../../semimagemescudo.png");
  const [semImagem, setSemImagem] = useState<any>("../../../semimagem.png");
  const [dadosLiga, setDadosLiga] = useState<IListagemLigas>();
  const [showModalMensagem, setShowModalMensagem] = useState(false);
  const [redirecionar, setRedirecionar] = useState("");
  const [searchParams, SetSearchParams] = useSearchParams();
  const [temporadaFiltro, setTemporadaFiltro] = useState(0);
  const [temporadaCalouroFiltro, setTemporadaCalouroFiltro] = useState(0);
  const [quantidadeJogosFiltro, setQuantidadeJogosFiltro] = useState(0);
  const [chkFgm, setChkFgm] = useState(false);
  const [xFgm, setXFgm] = useState(6);
  const [chkFga, setChkFga] = useState(false);// 
  const [xFga, setXFga] = useState(6);
  const [chkFge, setChkFge] = useState(false);//
  const [xFge, setXFge] = useState(6);
  const [chkFte, setChkFte] = useState(false);//
  const [xFte, setXFte] = useState(6);
  const [chkFta, setChkFta] = useState(false);//
  const [xFta, setXFta] = useState(6);
  const [chkFgp, setChkFgp] = useState(false);
  const [xFgp, setXFgp] = useState(6);
  const [chkFgmp, setChkFgmp] = useState(false);//
  const [xFgmp, setXFgmp] = useState(6);
  const [chkFtm, setChkFtm] = useState(false);
  const [xFtm, setXFtm] = useState(6);
  const [chkFtmp, setChkFtmp] = useState(false);//
  const [xFtmp, setXFtmp] = useState(6);
  const [chkFtp, setChkFtp] = useState(false);
  const [xFtp, setXFtp] = useState(6);
  const [chk3pm, setChk3pm] = useState(false);
  const [x3pm, setX3pm] = useState(6);
  const [chk3pa, setChk3pa] = useState(false);//
  const [x3pa, setX3pa] = useState(6);
  const [chk3pe, setChk3pe] = useState(false);
  const [x3pe, setX3pe] = useState(6);
  const [chk3pmp, setChk3pmp] = useState(false);
  const [x3pmp, setX3pmp] = useState(6);
  const [chkPts, setChkPts] = useState(false);
  const [xPts, setXPts] = useState(6);
  const [chkDReb, setChkDReb] = useState(false);
  const [xDReb, setXDReb] = useState(6);
  const [chkOReb, setChkOReb] = useState(false);
  const [xOReb, setXOReb] = useState(6);
  const [chkTReb, setChkTReb] = useState(false);
  const [xTReb, setXTReb] = useState(6);
  const [chkAst, setChkAst] = useState(false);
  const [xAst, setXAst] = useState(6);
  const [chkStl, setChkStl] = useState(false);
  const [xStl, setXStl] = useState(6);
  const [chkBlk, setChkBlk] = useState(false);
  const [xBlk, setXBlk] = useState(6);
  const [chkTurnovers, setChkTurnovers] = useState(false);
  const [xTurnovers, setXTurnovers] = useState(6);
  const [chkFaltas, setChkFaltas] = useState(false);
  const [xFaltas, setXFaltas] = useState(6);

  const [chkMinPlus, setChkMinPlus] = useState(false);
  const [xMinPlus, setXMinPlus] = useState(6);
  const [chkStocks, setChkStocks] = useState(false);
  const [xStocks, setXStocks] = useState(6);

  const [tipoFiltro, setTipoFiltro] = useState(1);
  const [dataInicioFiltro, setDataInicioFiltro] = useState("");
  const [dataFimFiltro, setDataFimFiltro] = useState("");

  const [opcoesAutoCompleteJogador, setOpcoesAutoCompleteJogador] = useState<TDropOptions[]>([]);
  const [selectedIdComplete, setSelectedIdComplete] = useState<number | undefined>(0);
  const [codigoFranquiaNbaFiltro, setCodigoFranquiaNbaFiltro] = useState(0);
  const [codigoFranquiaLigaFiltro, setCodigoFranquiaLigaFiltro] = useState(0);
  const [posicaoFiltro, setPosicaoFiltro] = useState("");
  const [lstFranquiasNBA, setLstFranquiasNBA] = useState<ILstDrop[]>([]);
  const [lstFranquias, setLstFranquias] = useState<ILstDrop[]>([]);
  const [lstPosicoes, setLstPosicoes] = useState<ILstDrop[]>([]);
  const [lstTemporadas, setLstTemporadas] = useState<ILstDrop[]>([]);
  const [estatisticasRows, setEstatisticasRows] = useState<IListaDadosMediaJogadores[]>([]);
  const [lstJogadores, setLstJogadores] = useState<ILstDrop[]>([]);
  const [dropJogador0, setDropFranquia0] = useState(0);
  const [dropJogador1, setDropFranquia1] = useState(0);
  const [dropJogador2, setDropFranquia2] = useState(0);
  const [dropJogador3, setDropFranquia3] = useState(0);
  const [dropJogador4, setDropFranquia4] = useState(0);
  const [dropJogador5, setDropFranquia5] = useState(0);
  const [dropJogador6, setDropFranquia6] = useState(0);
  const [dropJogador7, setDropFranquia7] = useState(0);
  const [dropJogador8, setDropFranquia8] = useState(0);
  const [dropJogador9, setDropFranquia9] = useState(0);
  const [dropJogador10, setDropFranquia10] = useState(0);
  const [dropJogador11, setDropFranquia11] = useState(0);
  const [dropJogador12, setDropFranquia12] = useState(0);
  const [dropJogador13, setDropFranquia13] = useState(0);
  const [dropJogador14, setDropFranquia14] = useState(0);
  const [dropJogador15, setDropFranquia15] = useState(0);
  const [dropJogador16, setDropFranquia16] = useState(0);
  const [dropJogador17, setDropFranquia17] = useState(0);
  const [dropJogador18, setDropFranquia18] = useState(0);
  const [dropJogador19, setDropFranquia19] = useState(0);
  const [dropJogador20, setDropFranquia20] = useState(0);
  const [dropJogador21, setDropFranquia21] = useState(0);
  const [dropJogador22, setDropFranquia22] = useState(0);
  const [dropJogador23, setDropFranquia23] = useState(0);
  const [dropJogador24, setDropFranquia24] = useState(0);
  const [dropJogador25, setDropFranquia25] = useState(0);

  //const [meusJogadoresRows, setMeusJogadoresRows] = useState<IListagemMeusJogadores[]>([]);
  const [dadosModalMensagem, setDadosModalMensagem] = useState<IDadosModal>({
    acao: false,
    label: "",
    tipo: "error",
    mensagem: "Sessão Expirada!",
    display: "none",
    titulo: "Atenção"
  });

  const [showModalEvent, setShowModalEvent] = useState(false);
  const [dadosModalEvent, setDadosModalEvent] = useState<IDadosModalEvento>({
    acao: false,
    label: "",
    tipo: "info",
    mensagem: "Deseja ronovar com o jogador ",
    display: "none",
    titulo: "Atenção"
  });

  const [errors, setErrors] = useState({
    error: false,
    nomeFranquiaRef: "",
    showImagemFranquia: ""
  });

  useEffect(() => {
    setIsLoading(true);
    const fetchData = async () => {
      if (codigoLiga === "" || codigoLiga === null || codigoLiga === "0") {
        setShowModalMensagem(true);
        setDadosModalMensagem({
          acao: true,
          label: "",
          tipo: "warning",
          mensagem: "Favor selecionar uma liga!",
          display: "none",
          titulo: "Atenção"
        });
        setRedirecionar("/dashboard");
        return;
      } else {

        let dadosStats: IDadosMetodo[] | undefined = [];
        await LigaService.getById(Number(codigoLiga))
          .then((result) => {
            dadosStats = result.dado.configuracao_Disputa;           
            setChkAst(dadosStats?.some(e => e.stats === 11) ? true : false);
            setChkBlk(dadosStats?.some(e => e.stats === 13) ? true : false);
            setChkFaltas(dadosStats?.some(e => e.stats === 15) ? true : false);
            setChkFgm(dadosStats?.some(e => e.stats === 1) ? true : false);
            setChkFga(dadosStats?.some(e => e.stats === 2) ? true : false);
            setChkFge(dadosStats?.some(e => e.stats === 20) ? true : false);
            setChkFtm(dadosStats?.some(e => e.stats === 3) ? true : false);
            setChkFte(dadosStats?.some(e => e.stats === 21) ? true : false);
            setChkFta(dadosStats?.some(e => e.stats === 4) ? true : false);
            setChkMinPlus(dadosStats?.some(e => e.stats === 16) ? true : false);
            setChkPts(dadosStats?.some(e => e.stats === 7) ? true : false);
            setChkTReb(dadosStats?.some(e => e.stats === 8) ? true : false);
            setChkDReb(dadosStats?.some(e => e.stats === 10) ? true : false);
            setChkOReb(dadosStats?.some(e => e.stats === 9) ? true : false);
            setChkStl(dadosStats?.some(e => e.stats === 12) ? true : false);
            setChk3pm(dadosStats?.some(e => e.stats === 5) ? true : false);
            setChk3pe(dadosStats?.some(e => e.stats === 22) ? true : false);
            setChk3pa(dadosStats?.some(e => e.stats === 6) ? true : false);
            setChkTurnovers(dadosStats?.some(e => e.stats === 14) ? true : false);
            setChkStocks(dadosStats?.some(e => e.stats === 23) ? true : false);
            setChkFgmp(dadosStats?.some(e => e.stats === 17) ? true : false);
            setChkFtmp(dadosStats?.some(e => e.stats === 18) ? true : false);
            setChk3pmp(dadosStats?.some(e => e.stats === 19) ? true : false);
          })
          .catch((errors) => {
            setShowModalMensagem(true);
            setRemoveLoading(true);
            if (errors.response.status === 401) {
              setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: "Sessão expirada!",
                display: "none",
                titulo: "Atenção"
              });
              logout();
              setRedirecionar("0");
              return;
            }

            setDadosModalMensagem({
              acao: true,
              label: "",
              tipo: "error",
              mensagem: errors.response.data.mensagem,
              display: "none",
              titulo: "Atenção"
            });
            setRedirecionar(`/usuario/liga/${codLocal}`);
            return;
          });


        await UtilidadeService.getTemporadasLigaPorTipoQtd(Number(codigoLiga), 1, 4, 0)
          .then((result) => {
            const tmps = result.data.dado;
            let lstTemporadasAux = tmps.map((f, i) => ({ codigo: f.codigo, label: f.descricao_Temporada }));
            setLstTemporadas(lstTemporadasAux);
          })
          .catch((errors) => {
            setShowModalMensagem(true);
            if (errors.response.status === 401) {
              setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: "Sessão expirada!",
                display: "none",
                titulo: "Atenção"
              });
              logout();
              setRedirecionar("0");
              return;
            }
            setDadosModalMensagem({
              acao: true,
              label: "",
              tipo: "error",
              mensagem: errors.response.data.mensagem,
              display: "none",
              titulo: "Atenção"
            });
          });


        await FranquiaService.getByIdLiga(Number(codigoLiga)).then(result => {
          let lstFranquia = result.dado.map((f, i) => ({ codigo: f.codigo, label: f.nome === null ? `Franquia ${i + 1} ` : f.nome }));
          setLstFranquias(lstFranquia);
        }).catch((errors) => {
          setRemoveLoading(true);
          setIsLoading(false);
          setShowModalMensagem(true);
          if (errors.response.data.statusHTTP === 401) {
            setDadosModalMensagem({
              acao: true,
              label: "",
              tipo: "error",
              mensagem: "Sessão Expirada! 2",
              display: "none",
              titulo: "Atenção"
            });
            logout();
            setRedirecionar("0");
            return;
          }
          if (errors.response.data.mensagem !== undefined) {
            setDadosModalMensagem({
              acao: true,
              label: "",
              tipo: "error",
              mensagem: errors.response.data.mensagem,
              display: "none",
              titulo: "Atenção"
            });
          }
          else {
            setDadosModalMensagem({
              acao: true,
              label: "",
              tipo: "error",
              mensagem: "Não foi possível carregar os dados da franquia! Favor entrar em contato com a TI",
              display: "none",
              titulo: "Atenção"
            });
          }
        });

        await FranquiaService.getFranquiaNBA()
          .then(result => {
            let lstFranquiaNBA = result.dado.map((f, i) => ({ codigo: f.codigo_NBA, label: f.nome === null ? `Franquia ${i + 1} ` : f.nome }));
            setLstFranquiasNBA(lstFranquiaNBA);
          }).catch((errors) => {
            setRemoveLoading(true);
            setIsLoading(false);
            setShowModalMensagem(true);
            if (errors.response.data.statusHTTP === 401) {
              setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "error",
                mensagem: "Sessão Expirada! 2",
                display: "none",
                titulo: "Atenção"
              });
              logout();
              setRedirecionar("0");
              return;
            }
            if (errors.response.data.mensagem !== undefined) {
              setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "error",
                mensagem: errors.response.data.mensagem,
                display: "none",
                titulo: "Atenção"
              });
            }
            else {
              setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "error",
                mensagem: "Não foi possível carregar os dados da franquia! Favor entrar em contato com a TI",
                display: "none",
                titulo: "Atenção"
              });
            }
          });

        await LigaService.getDadosLigaPeloCodigo(Number(codigoLiga))
          .then((result) => {
            const liga = result.dado;
            setDadosLiga(liga);          
            if (liga.caminho_Logo !== null) {
              setShowImagemFranquia(liga.caminho_Logo);
            }
            setTemporadaFiltro(liga.codigo_Temporada);

            const lst: TDropOptions[] = liga.codigo_Tipo_Posicao_Confronto === 2
              ? lstPosicaoAmericano.map((f) => ({ codigo: f.codigo, label: f.label, descricao: f.label }))
              : lstReferenciasPosicao.map((f) => ({ codigo: f.codigo, label: f.label, descricao: f.label }));
            setLstPosicoes(lst)

            carregarDadosMediasJogadores(Number(codigoLiga), liga.codigo_Temporada, 1, true, null, 6, dadosStats, true, false);

          })
          .catch((errors) => {
            setShowModalMensagem(true);
            setRemoveLoading(true);
            if (errors.response.status === 401) {
              setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: "Sessão expirada!",
                display: "none",
                titulo: "Atenção"
              });
              logout();
              setRedirecionar("0");
              return;
            }

            setDadosModalMensagem({
              acao: true,
              label: "",
              tipo: "error",
              mensagem: errors.response.data.mensagem,
              display: "none",
              titulo: "Atenção"
            });
            setRedirecionar(`/usuario/liga/${codLocal}`);
            return;
          });



      }
    }
    fetchData();
  }, []);

  const autoCompleteSelectedOption = useMemo(() => {
    if (!selectedIdComplete) return null;

    const selectedOption = opcoesAutoCompleteJogador.find(opcao => opcao.codigo === selectedIdComplete);
    if (!selectedOption) return null;

    return selectedOption;
  }, [selectedIdComplete, opcoesAutoCompleteJogador]);


  const carregarDadosMediasJogadores = async (codigoLiga: number,
    codigoTemporada: number,
    tipo: number,
    atualizarAutoComplete: boolean,
    stats: string | null,
    peso: number,
    dadosStats: IDadosMetodo[] | undefined,
    inicio: boolean,
    valorChkBox: boolean
  ) => {
    setIsLoading(true);
    setRemoveLoading(false);
    setTipoFiltro(tipo);

    let dadosFiltros: IDadosFiltrosJogadores = {
      codigoLiga: codigoLiga,
      codigoTemporada: codigoTemporada,
      codigoJogador: selectedIdComplete === 0 ? null : selectedIdComplete,
      codigoFranquiaLiga: codigoFranquiaLigaFiltro === 0 ? null : codigoFranquiaLigaFiltro,
      codigoFranquiaNBA: codigoFranquiaNbaFiltro === 0 ? null : codigoFranquiaNbaFiltro,
      posicao: posicaoFiltro === "" || posicaoFiltro === "0" ? null : posicaoFiltro,
      codigoTemporadaCalouro: temporadaCalouroFiltro,
      dataInicio: dataInicioFiltro,
      dataFim: dataFimFiltro,
      quantidadeDeJogos: quantidadeJogosFiltro,
      ast: inicio && dadosStats?.some(e => e.stats === 11) ? true : stats === "ast" ? valorChkBox : chkAst,
      peso_AST: handleConverteValorPeso(stats === "ast" ? peso : xAst),//
      blk: inicio && dadosStats?.some(e => e.stats === 13) ? true : stats === "blk" ? valorChkBox : chkBlk,
      peso_BLK: handleConverteValorPeso(stats === "blk" ? peso : xBlk),// 
      pf: inicio && dadosStats?.some(e => e.stats === 15) ? true : stats === "pf" ? valorChkBox : chkFaltas,
      peso_PF: handleConverteValorPeso(stats === "pf" ? peso : xFaltas),
      fgm: inicio && dadosStats?.some(e => e.stats === 1) ? true : stats === "fgm" ? valorChkBox : chkFgm,
      peso_FGM: handleConverteValorPeso(stats === "fgm" ? peso : xFgm),
      fga: inicio && dadosStats?.some(e => e.stats === 2) ? true : stats === "fga" ? valorChkBox : chkFga,
      peso_FGA: handleConverteValorPeso(stats === "fga" ? peso : xFga),
      fge: inicio && dadosStats?.some(e => e.stats === 20) ? true : stats === "fge" ? valorChkBox : chkFge,
      peso_FGE: handleConverteValorPeso(stats === "fge" ? peso : xFge),
      ftm: inicio && dadosStats?.some(e => e.stats === 3) ? true : stats === "ftm" ? valorChkBox : chkFtm,
      peso_FTM: handleConverteValorPeso(stats === "ftm" ? peso : xFtm),
      fte: inicio && dadosStats?.some(e => e.stats === 21) ? true : stats === "fte" ? valorChkBox : chkFte,
      peso_FTE: handleConverteValorPeso(stats === "fte" ? peso : xFte),
      fta: inicio && dadosStats?.some(e => e.stats === 4) ? true : stats === "fta" ? valorChkBox : chkFta,
      peso_FTA: handleConverteValorPeso(stats === "fta" ? peso : xFta),
      mplu: inicio && dadosStats?.some(e => e.stats === 16) ? true : stats === "mplu" ? valorChkBox : chkMinPlus,
      peso_MPLU: handleConverteValorPeso(stats === "mplu" ? peso : xMinPlus),
      pts: inicio && dadosStats?.some(e => e.stats === 7) ? true : stats === "pts" ? valorChkBox : chkPts,
      peso_PTS: handleConverteValorPeso(stats === "pts" ? peso : xPts),
      reb: inicio && dadosStats?.some(e => e.stats === 8) ? true : stats === "reb" ? valorChkBox : chkTReb,
      peso_REB: handleConverteValorPeso(stats === "reb" ? peso : xTReb),
      dreb: inicio && dadosStats?.some(e => e.stats === 10) ? true : stats === "dreb" ? valorChkBox : chkDReb,
      peso_DREB: handleConverteValorPeso(stats === "dreb" ? peso : xDReb),
      oreb: inicio && dadosStats?.some(e => e.stats === 9) ? true : stats === "oreb" ? valorChkBox : chkOReb,
      peso_OREB: handleConverteValorPeso(stats === "oreb" ? peso : xOReb),
      stl: inicio && dadosStats?.some(e => e.stats === 12) ? true : stats === "stl" ? valorChkBox : chkStl,
      peso_STL: handleConverteValorPeso(stats === "stl" ? peso : xStl),
      threepm: inicio && dadosStats?.some(e => e.stats === 5) ? true : stats === "threepm" ? valorChkBox : chk3pm,
      peso_THREEPM: handleConverteValorPeso(stats === "threepm" ? peso : x3pm),
      threepe: inicio && dadosStats?.some(e => e.stats === 22) ? true : stats === "threepe" ? valorChkBox : chk3pe,
      peso_THREEPE: handleConverteValorPeso(stats === "threepe" ? peso : x3pe),
      threepa: inicio && dadosStats?.some(e => e.stats === 6) ? true : stats === "threepa" ? valorChkBox : chk3pa,
      peso_THREEPA: handleConverteValorPeso(stats === "threepa" ? peso : x3pa),
      tor: inicio && dadosStats?.some(e => e.stats === 14) ? true : stats === "to" ? valorChkBox : chkTurnovers,
      peso_TO: handleConverteValorPeso(stats === "to" ? peso : xTurnovers),
      stocks: inicio && dadosStats?.some(e => e.stats === 23) ? true : stats === "stocks" ? valorChkBox : chkStocks,
      peso_STOCKS: handleConverteValorPeso(stats === "stocks" ? peso : xStocks),
      fgmp: inicio && dadosStats?.some(e => e.stats === 17) ? true : stats === "fgmp" ? valorChkBox : chkFgmp,
      peso_FGMP: handleConverteValorPeso(stats === "fgmp" ? peso : xFgmp),
      ftmp: inicio && dadosStats?.some(e => e.stats === 18) ? true : stats === "ftmp" ? valorChkBox : chkFtmp,
      peso_FTMP: handleConverteValorPeso(stats === "ftmp" ? peso : xFtmp),
      threepmp: inicio && dadosStats?.some(e => e.stats === 19) ? true : stats === "threepmp" ? valorChkBox : chk3pmp,
      peso_THREEPMP: handleConverteValorPeso(stats === "threepmp" ? peso : x3pmp),

    }

    console.log("dadosFiltros");
    console.log(dadosFiltros);
    handleRealizarConsulta(tipo, dadosFiltros, atualizarAutoComplete);


  }


  const handleRealizarConsulta = async (tipo: number, dadosFiltros: IDadosFiltrosJogadores, atualizarAutoComplete: boolean) => {
    if (tipo === 1) {
      EstatisticasService.getMediaJogadoresNBA(dadosFiltros)
        .then((result) => {
          const lstDados = result.dado;
          setEstatisticasRows(lstDados);
          let lstJogadores = result.dado.map((f, i) => ({ codigo: f.codigo !== undefined ? f.codigo : 0, label: f.nome === null ? `setDropJogador${i} ` : f.nome }));
          setLstJogadores(lstJogadores.sort((a, b) => a.label > b.label ? 1 : -1));
          const lstDrop: TDropOptions[] = lstJogadores.sort((a, b) => a.label > b.label ? 1 : -1)
            .map((f, i) => ({ codigo: f.codigo, label: f.label, descricao: "" }));
          if (atualizarAutoComplete === true)
            setOpcoesAutoCompleteJogador(lstDrop);
          setIsLoading(false);
          setRemoveLoading(true);
        })
        .catch((errors) => {
          setShowModalMensagem(true);
          setRemoveLoading(true);
          if (errors.response) {
            if (errors.response.status === 401) {
              setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: "Sessão expirada!",
                display: "none",
                titulo: "Atenção"
              });
              logout();
              setRedirecionar("0");
              return;
            }

            setDadosModalMensagem({
              acao: true,
              label: "",
              tipo: "error",
              mensagem: errors.response.data.mensagem,
              display: "none",
              titulo: "Atenção"
            });
            return;
          }

          setDadosModalMensagem({
            acao: true,
            label: "",
            tipo: "error",
            mensagem: "Não foi possível carregar os dados! Tente novamente mais tarde e caso o problema persista, favor entrar em contato com a TI.",
            display: "none",
            titulo: "Atenção"
          });

          setRedirecionar(`/usuario/liga/${codLocal}`);
          return;
        });
    }
    else if (tipo === 2) {
      EstatisticasService.getMediaJogadores(dadosFiltros)
        .then((result) => {
          const lstDados = result.dado;
          setEstatisticasRows(lstDados);
          let lstJogadores = result.dado.map((f, i) => ({ codigo: f.codigo !== undefined ? f.codigo : 0, label: f.nome === null ? `setDropJogador${i} ` : f.nome }));
          setLstJogadores(lstJogadores.sort((a, b) => a.label > b.label ? 1 : -1));
          const lstDrop: TDropOptions[] = lstJogadores.sort((a, b) => a.label > b.label ? 1 : -1)
            .map((f, i) => ({ codigo: f.codigo, label: f.label, descricao: "" }));
          if (atualizarAutoComplete === true)
            setOpcoesAutoCompleteJogador(lstDrop);
          setIsLoading(false);
          setRemoveLoading(true);
        })
        .catch((errors) => {
          setShowModalMensagem(true);
          setIsLoading(false);
          setRemoveLoading(true);
          if (errors.response) {
            if (errors.response.status === 401) {
              setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: "Sessão expirada!",
                display: "none",
                titulo: "Atenção"
              });
              logout();
              setRedirecionar("0");
              return;
            }

            setDadosModalMensagem({
              acao: true,
              label: "",
              tipo: "error",
              mensagem: errors.response.data.mensagem,
              display: "none",
              titulo: "Atenção"
            });
            return;
          }

          setDadosModalMensagem({
            acao: true,
            label: "",
            tipo: "error",
            mensagem: "Não foi possível carregar os dados! Tente novamente mais tarde e caso o problema persista, favor entrar em contato com a TI.",
            display: "none",
            titulo: "Atenção"
          });

          setRedirecionar(`/usuario/liga/${codLocal}`);
          return;
        });
    }
  }
  const toggleModalMensagem = () => {
    setShowModalMensagem(modalVisivel => !modalVisivel);
    if (redirecionar !== "") {
      redirecionar.length === 1 ? navigate(0) : navigate(redirecionar);
    }
  };

  const toggleModalEvent = () => {
    setShowModalEvent(modalVisivel => !modalVisivel);
    if (redirecionar !== "") {
      redirecionar.length === 1 || CookieService.get("access_token") === undefined ? navigate(0) : navigate(redirecionar);
    }
  }

  const handleSelectedTemporada = async (e: { target: { name: string; value: any; }; }) => {
    setTemporadaFiltro(e.target.value);
    setEstatisticasRows([]);
    carregarDadosMediasJogadores(Number(codigoLiga), Number(e.target.value), Number(tipoFiltro), false, null, 6, [], false, false);
  }

  const handleChangeTipo = async (e: { target: { name: string; value: any; }; }) => {
    setTipoFiltro(e.target.value);
    setEstatisticasRows([]);
    carregarDadosMediasJogadores(Number(codigoLiga), temporadaFiltro, Number(e.target.value), false, null, 6, [], false, false);

  }

  const carregaPosicao = (posicao_1: string, posicao_2: string | null, posicao_3: string | null) => {
    if (posicao_1 === null) {
      return posicao_1;
    }

    let posicoes = `${UtilidadeService.verificaTipoPosicao(posicao_1)} ${posicao_2 !== null ? " | " : ""} ${posicao_2 !== null ? UtilidadeService.verificaTipoPosicao(posicao_2) : ""} ${posicao_3 !== null ? " | " : ""} ${posicao_3 !== null ? UtilidadeService.verificaTipoPosicao(posicao_3) : ""}`;
    let qtd = posicoes.split("|").length;
    let arrImagens = posicoes.split("|");

    let imgs = qtd === 1 ? <img src={`../../${arrImagens[0]}`} alt={"img1"} width={UtilidadeService.isMobile() ? 18 : 25} height={UtilidadeService.isMobile() ? 18 : 25} style={{ borderRadius: "50%" }} />
      : qtd === 2 ?
        <>  <img src={`../../${arrImagens[0]}`} alt={"img1"} width={UtilidadeService.isMobile() ? 18 : 25} height={UtilidadeService.isMobile() ? 18 : 25} style={{ borderRadius: "50%" }} />
          <img src={`../../${arrImagens[1].replaceAll(" ", "")}`} alt={"img2"} width={UtilidadeService.isMobile() ? 18 : 25} height={UtilidadeService.isMobile() ? 18 : 25} style={{ borderRadius: "50%", marginLeft: 4 }} />
        </>
        : <> <img src={`../../${arrImagens[0]}`} alt={"img1"} width={UtilidadeService.isMobile() ? 18 : 25} height={UtilidadeService.isMobile() ? 18 : 25} style={{ borderRadius: "50%" }} />
          <img src={`../../${arrImagens[1].replaceAll(" ", "")}`} alt={"img2"} width={UtilidadeService.isMobile() ? 18 : 25} height={UtilidadeService.isMobile() ? 18 : 25} style={{ borderRadius: "50%", marginLeft: 4 }} />
          <img src={`../../${arrImagens[2].replaceAll(" ", "")}`} alt={"img3"} width={UtilidadeService.isMobile() ? 18 : 25} height={UtilidadeService.isMobile() ? 18 : 25} style={{ borderRadius: "50%", marginLeft: 4 }} />
        </>

    return imgs
  }

  const columnsGeral: GridColDef[] = [
    {
      field: 'codigo',
      headerName: '',
      flex: 1,
      minWidth: 55,
      maxWidth: 55,
      headerClassName: 'super-app-theme--header',
      align: 'center',
      headerAlign: 'center',
      sortable: false


    },
    {
      field: 'foto',
      headerName: 'FOTO',
      editable: false,
      flex: 1,
      minWidth: 75,
      maxWidth: 75,
      headerClassName: 'super-app-theme--header',
      //renderCell: (params) => params.value !== null ? <img src={params.value} width={45} height={50} /> : null,
      renderCell: (params) => (params.value !== null && params.value !== "" && params.value !== undefined)
        ? <img src={params.value} width={UtilidadeService.isMobile() ? 35 : 50} height={UtilidadeService.isMobile() ? 35 : 50}
          onError={({ currentTarget }) => {
            currentTarget.onerror = null;
            currentTarget.src = "../../../../semimagem.png";
            currentTarget.style.borderRadius = "50%";
            currentTarget.style.width = UtilidadeService.isMobile() ? "30px" : "40px";
            currentTarget.style.height = UtilidadeService.isMobile() ? "30px" : "40px";
          }} />
        : <img src={"../../../../semimagem.png"} width={UtilidadeService.isMobile() ? 30 : 40} height={UtilidadeService.isMobile() ? 30 : 40} style={{ borderRadius: "50%" }} />,
      sortable: false
    },
    {
      field: 'nome',
      headerName: 'NOME',
      flex: 1,
      minWidth: 150,
      editable: true,
      headerClassName: 'super-app-theme--header',
      sortable: false


    },
    {
      field: 'posicao_Liga_1',
      headerName: 'POSIÇÃO',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 100,
      sortable: false,
      editable: false,
      renderCell: (params) => carregaPosicao(params.row.posicao_Liga_1, params.row.posicao_Liga_2, params.row.posicao_Liga_3),
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'quantidade_Jogos',
      headerName: 'QTD',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 90,
      maxWidth: 90,
      editable: false,
      align: 'center',
      headerAlign: 'center',
      //sortable: false
    },
    {
      field: 'min',
      headerName: 'MIN',
      editable: false,
      flex: 1,
      minWidth: 90,
      maxWidth: 90,
      headerClassName: 'super-app-theme--header',
      align: 'center',
      headerAlign: 'center',
      //cellClassName: 'super-app-theme--cell',
      renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : null,
      //sortable: false
    },
    {
      field: 'fgm',
      headerName: 'FGM',
      editable: false,
      flex: 1,
      minWidth: 90,
      maxWidth: 90,
      headerClassName: 'super-app-theme--header',
      align: 'center',
      headerAlign: 'center',
      //cellClassName: 'super-app-theme--cell',
      renderCell: (params) =>
      (
        <Box
          sx={{
            color: params.row.color_Fgm === null || params.row.color_Fgm === undefined ? "auto" : "black",
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: params.row.color_Fgm === null || params.row.color_Fgm === undefined ? "auto" : params.row.color_Fgm
            // value >= 25 ? "#079b00" 
            // : params.value > 20 && params.value < 25 ? "#5cd856" 
            // : params.value > 19 && params.value < 20 ? "#abe5a8" 
            // : params.value > 18 && params.value < 19 ? "#f8f9fa" 
            // : params.value > 16 && params.value < 18 ?  "#db9d9d"
            // : "#e70b0b" , // Conditional background
          }}
        >
          {params.value !== null ? params.value.toFixed(2).replace(".", ",") : null}
        </Box>
      ),
      //sortable: false
    },
    {
      field: 'fga',
      headerName: 'FGA',
      editable: false,
      flex: 1,
      minWidth: 90,
      maxWidth: 90,
      headerClassName: 'super-app-theme--header',
      align: 'center',
      headerAlign: 'center',
      //cellClassName: 'super-app-theme--cell',
      renderCell: (params) =>
      (
        <Box
          sx={{
            color: params.row.color_Fga === null || params.row.color_Fga === undefined ? "auto" : "black",
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: params.row.color_Fga === null || params.row.color_Fga === undefined ? "auto" : params.row.color_Fga
            // value >= 25 ? "#079b00" 
            // : params.value > 20 && params.value < 25 ? "#5cd856" 
            // : params.value > 19 && params.value < 20 ? "#abe5a8" 
            // : params.value > 18 && params.value < 19 ? "#f8f9fa" 
            // : params.value > 16 && params.value < 18 ?  "#db9d9d"
            // : "#e70b0b" , // Conditional background
          }}
        >
          {params.value !== null ? params.value.toFixed(2).replace(".", ",") : null}
        </Box>
      ),
      //sortable: false
    },
    {
      field: 'ftm',
      headerName: 'FTM',
      editable: false,
      flex: 1,
      minWidth: 90,
      maxWidth: 90,
      headerClassName: 'super-app-theme--header',
      align: 'center',
      headerAlign: 'center',
      //cellClassName: 'super-app-theme--cell',
      renderCell: (params) =>
      (
        <Box
          sx={{
            color: params.row.color_Ftm === null || params.row.color_Ftm === undefined ? "auto" : "black",
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: params.row.color_Ftm === null || params.row.color_Ftm === undefined ? "auto" : params.row.color_Ftm
            // value >= 25 ? "#079b00" 
            // : params.value > 20 && params.value < 25 ? "#5cd856" 
            // : params.value > 19 && params.value < 20 ? "#abe5a8" 
            // : params.value > 18 && params.value < 19 ? "#f8f9fa" 
            // : params.value > 16 && params.value < 18 ?  "#db9d9d"
            // : "#e70b0b" , // Conditional background
          }}
        >
          {params.value !== null ? params.value.toFixed(2).replace(".", ",") : null}
        </Box>
      ),
      //sortable: false
    },
    {
      field: 'fta',
      headerName: 'FTA',
      editable: false,
      flex: 1,
      minWidth: 90,
      maxWidth: 90,
      headerClassName: 'super-app-theme--header',
      align: 'center',
      headerAlign: 'center',
      //cellClassName: 'super-app-theme--cell',
      renderCell: (params) =>
      (
        <Box
          sx={{
            color: params.row.color_Fta === null || params.row.color_Fta === undefined ? "auto" : "black",
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: params.row.color_Fta === null || params.row.color_Fta === undefined ? "auto" : params.row.color_Fta
            // value >= 25 ? "#079b00" 
            // : params.value > 20 && params.value < 25 ? "#5cd856" 
            // : params.value > 19 && params.value < 20 ? "#abe5a8" 
            // : params.value > 18 && params.value < 19 ? "#f8f9fa" 
            // : params.value > 16 && params.value < 18 ?  "#db9d9d"
            // : "#e70b0b" , // Conditional background
          }}
        >
          {params.value !== null ? params.value.toFixed(2).replace(".", ",") : null}
        </Box>
      ),
      //sortable: false
    },
    {
      field: 'pts',
      headerName: 'PTS',
      editable: false,
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 90,
      maxWidth: 90,
      align: 'center',
      headerAlign: 'center',
      //cellClassName: 'super-app-theme--cell',
      renderCell: (params) =>
      (
        <Box
          sx={{
            color: params.row.color_Pts === null || params.row.color_Pts === undefined ? "auto" : "black",
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: params.row.color_Pts === null || params.row.color_Pts === undefined ? "auto" : params.row.color_Pts
            // value >= 25 ? "#079b00" 
            // : params.value > 20 && params.value < 25 ? "#5cd856" 
            // : params.value > 19 && params.value < 20 ? "#abe5a8" 
            // : params.value > 18 && params.value < 19 ? "#f8f9fa" 
            // : params.value > 16 && params.value < 18 ?  "#db9d9d"
            // : "#e70b0b" , // Conditional background
          }}
        >
          {params.value !== null ? params.value.toFixed(2).replace(".", ",") : null}
        </Box>
      ),
      //sortable: false
    },
    {
      field: 'reb',
      headerName: 'REB',
      editable: false,
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 90,
      maxWidth: 90,
      align: 'center',
      headerAlign: 'center',
      //cellClassName: 'super-app-theme--cell',
      renderCell: (params) =>
      (
        <Box
          sx={{
            color: params.row.color_Reb === null || params.row.color_Reb === undefined ? "auto" : "black",
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: params.row.color_Reb === null || params.row.color_Reb === undefined ? "auto" : params.row.color_Reb
            // value >= 25 ? "#079b00" 
            // : params.value > 20 && params.value < 25 ? "#5cd856" 
            // : params.value > 19 && params.value < 20 ? "#abe5a8" 
            // : params.value > 18 && params.value < 19 ? "#f8f9fa" 
            // : params.value > 16 && params.value < 18 ?  "#db9d9d"
            // : "#e70b0b" , // Conditional background
          }}
        >
          {params.value !== null ? params.value.toFixed(2).replace(".", ",") : null}
        </Box>
      ),
      //sortable: false
    },
    {
      field: 'oreb',
      headerName: 'OREB',
      editable: false,
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 90,
      maxWidth: 90,
      align: 'center',
      headerAlign: 'center',
      //cellClassName: 'super-app-theme--cell',
      renderCell: (params) =>
      (
        <Box
          sx={{
            color: params.row.color_OReb === null || params.row.color_OReb === undefined ? "auto" : "black",
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: params.row.color_OReb === null || params.row.color_OReb === undefined ? "auto" : params.row.color_OReb
            // value >= 25 ? "#079b00" 
            // : params.value > 20 && params.value < 25 ? "#5cd856" 
            // : params.value > 19 && params.value < 20 ? "#abe5a8" 
            // : params.value > 18 && params.value < 19 ? "#f8f9fa" 
            // : params.value > 16 && params.value < 18 ?  "#db9d9d"
            // : "#e70b0b" , // Conditional background
          }}
        >
          {params.value !== null ? params.value.toFixed(2).replace(".", ",") : null}
        </Box>
      ),
      //sortable: false
    },
    {
      field: 'dreb',
      headerName: 'DREB',
      editable: false,
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 90,
      maxWidth: 90,
      align: 'center',
      headerAlign: 'center',
      //cellClassName: 'super-app-theme--cell',
      renderCell: (params) =>
      (
        <Box
          sx={{
            color: params.row.color_DReb === null || params.row.color_DReb === undefined ? "auto" : "black",
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: params.row.color_DReb === null || params.row.color_DReb === undefined ? "auto" : params.row.color_DReb
            // value >= 25 ? "#079b00" 
            // : params.value > 20 && params.value < 25 ? "#5cd856" 
            // : params.value > 19 && params.value < 20 ? "#abe5a8" 
            // : params.value > 18 && params.value < 19 ? "#f8f9fa" 
            // : params.value > 16 && params.value < 18 ?  "#db9d9d"
            // : "#e70b0b" , // Conditional background
          }}
        >
          {params.value !== null ? params.value.toFixed(2).replace(".", ",") : null}
        </Box>
      ),
      //sortable: false
    },
    {
      field: 'ast',
      headerName: 'AST',
      editable: false,
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 90,
      maxWidth: 90,
      align: 'center',
      headerAlign: 'center',
      //cellClassName: 'super-app-theme--cell',
      renderCell: (params) =>
      (
        <Box
          sx={{
            color: params.row.color_Ast === null || params.row.color_Ast === undefined ? "auto" : "black",
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: params.row.color_Ast === null || params.row.color_Ast === undefined ? "auto" : params.row.color_Ast
            // value >= 25 ? "#079b00" 
            // : params.value > 20 && params.value < 25 ? "#5cd856" 
            // : params.value > 19 && params.value < 20 ? "#abe5a8" 
            // : params.value > 18 && params.value < 19 ? "#f8f9fa" 
            // : params.value > 16 && params.value < 18 ?  "#db9d9d"
            // : "#e70b0b" , // Conditional background
          }}
        >
          {params.value !== null ? params.value.toFixed(2).replace(".", ",") : null}
        </Box>
      ),
      //sortable: false
    },
    {
      field: 'stl',
      headerName: 'STL',
      editable: false,
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 90,
      maxWidth: 90,
      align: 'center',
      headerAlign: 'center',
      //cellClassName: 'super-app-theme--cell',
      renderCell: (params) =>
      (
        <Box
          sx={{
            color: params.row.color_Stl === null || params.row.color_Stl === undefined ? "auto" : "black",
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: params.row.color_Stl === null || params.row.color_Stl === undefined ? "auto" : params.row.color_Stl
            // value >= 25 ? "#079b00" 
            // : params.value > 20 && params.value < 25 ? "#5cd856" 
            // : params.value > 19 && params.value < 20 ? "#abe5a8" 
            // : params.value > 18 && params.value < 19 ? "#f8f9fa" 
            // : params.value > 16 && params.value < 18 ?  "#db9d9d"
            // : "#e70b0b" , // Conditional background
          }}
        >
          {params.value !== null ? params.value.toFixed(2).replace(".", ",") : null}
        </Box>
      ),
      //sortable: false
    },
    {
      field: 'blk',
      headerName: 'BLK',
      editable: false,
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 90,
      maxWidth: 90,
      align: 'center',
      headerAlign: 'center',
      //cellClassName: 'super-app-theme--cell',
      renderCell: (params) =>
      (
        <Box
          sx={{
            color: params.row.color_Blk === null || params.row.color_Blk === undefined ? "auto" : "black",
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: params.row.color_Blk === null || params.row.color_Blk === undefined ? "auto" : params.row.color_Blk
            // value >= 25 ? "#079b00" 
            // : params.value > 20 && params.value < 25 ? "#5cd856" 
            // : params.value > 19 && params.value < 20 ? "#abe5a8" 
            // : params.value > 18 && params.value < 19 ? "#f8f9fa" 
            // : params.value > 16 && params.value < 18 ?  "#db9d9d"
            // : "#e70b0b" , // Conditional background
          }}
        >
          {params.value !== null ? params.value.toFixed(2).replace(".", ",") : null}
        </Box>
      ),
      //sortable: false
    },
    {
      field: 'to',
      headerName: 'TO',
      editable: false,
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 90,
      maxWidth: 90,
      align: 'center',
      headerAlign: 'center',
      //cellClassName: 'super-app-theme--cell',
      renderCell: (params) =>
      (
        <Box
          sx={{
            color: params.row.color_To === null || params.row.color_To === undefined ? "auto" : "black",
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: params.row.color_To === null || params.row.color_To === undefined ? "auto" : params.row.color_To
            // value >= 25 ? "#079b00" 
            // : params.value > 20 && params.value < 25 ? "#5cd856" 
            // : params.value > 19 && params.value < 20 ? "#abe5a8" 
            // : params.value > 18 && params.value < 19 ? "#f8f9fa" 
            // : params.value > 16 && params.value < 18 ?  "#db9d9d"
            // : "#e70b0b" , // Conditional background
          }}
        >
          {params.value !== null ? params.value.toFixed(2).replace(".", ",") : null}
        </Box>
      ),
      //sortable: false
    },
    {
      field: 'pf',
      headerName: 'PF',
      editable: false,
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 90,
      maxWidth: 90,
      align: 'center',
      headerAlign: 'center',
      //cellClassName: 'super-app-theme--cell',
      renderCell: (params) =>
      (
        <Box
          sx={{
            color: params.row.color_Pf === null || params.row.color_Pf === undefined ? "auto" : "black",
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: params.row.color_Pf === null || params.row.color_Pf === undefined ? "auto" : params.row.color_Pf
            // value >= 25 ? "#079b00" 
            // : params.value > 20 && params.value < 25 ? "#5cd856" 
            // : params.value > 19 && params.value < 20 ? "#abe5a8" 
            // : params.value > 18 && params.value < 19 ? "#f8f9fa" 
            // : params.value > 16 && params.value < 18 ?  "#db9d9d"
            // : "#e70b0b" , // Conditional background
          }}
        >
          {params.value !== null ? params.value.toFixed(2).replace(".", ",") : null}
        </Box>
      ),
      //sortable: false
    },
    {
      field: 'mplu',
      headerName: 'MPLU',
      editable: false,
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 90,
      maxWidth: 90,
      align: 'center',
      headerAlign: 'center',
      cellClassName: (params: GridCellParams<any, number>) => {

        if (params.value == null) {

          return clsx('super-app', {
            positive: true
          });
        }

        return clsx('super-app', {
          negative: parseFloat(params.value.toString()) < 0,
          positive: parseFloat(params.value.toString()) >= 0 || params.value === null || params.value === undefined,
        });

      },
      renderCell: (params) =>
      (
        <Box
          sx={{
            color: params.row.color_Mplu === null || params.row.color_Mplu === undefined ? "auto" : "black",
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: params.row.color_Mplu === null || params.row.color_Mplu === undefined ? "auto" : params.row.color_Mplu
            // value >= 25 ? "#079b00" 
            // : params.value > 20 && params.value < 25 ? "#5cd856" 
            // : params.value > 19 && params.value < 20 ? "#abe5a8" 
            // : params.value > 18 && params.value < 19 ? "#f8f9fa" 
            // : params.value > 16 && params.value < 18 ?  "#db9d9d"
            // : "#e70b0b" , // Conditional background
          }}
        >
          {params.value !== null ? params.value.toFixed(2).replace(".", ",") : null}
        </Box>
      ),
      //sortable: false
    },
    {
      field: 'fgmp',
      headerName: 'FGM%',
      editable: false,
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 90,
      maxWidth: 90,
      align: 'center',
      headerAlign: 'center',
      //cellClassName: 'super-app-theme--cell',
      renderCell: (params) =>
      (
        <Box
          sx={{
            color: params.row.color_Fgmp === null || params.row.color_Fgmp === undefined ? "auto" : "black",
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: params.row.color_Fgmp === null || params.row.color_Fgmp === undefined ? "auto" : params.row.color_Fgmp
            // value >= 25 ? "#079b00" 
            // : params.value > 20 && params.value < 25 ? "#5cd856" 
            // : params.value > 19 && params.value < 20 ? "#abe5a8" 
            // : params.value > 18 && params.value < 19 ? "#f8f9fa" 
            // : params.value > 16 && params.value < 18 ?  "#db9d9d"
            // : "#e70b0b" , // Conditional background
          }}
        >
          {params.value !== null ? params.value.toFixed(3).replace(".", ",") : null}
        </Box>
      ),
      //sortable: false
    },
    {
      field: 'ftmp',
      headerName: 'FTM%',
      editable: false,
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 90,
      maxWidth: 90,
      align: 'center',
      headerAlign: 'center',
      //cellClassName: 'super-app-theme--cell',
      renderCell: (params) =>
      (
        <Box
          sx={{
            color: params.row.color_Ftmp === null || params.row.color_Ftmp === undefined ? "auto" : "black",
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: params.row.color_Ftmp === null || params.row.color_Ftmp === undefined ? "auto" : params.row.color_Ftmp
            // value >= 25 ? "#079b00" 
            // : params.value > 20 && params.value < 25 ? "#5cd856" 
            // : params.value > 19 && params.value < 20 ? "#abe5a8" 
            // : params.value > 18 && params.value < 19 ? "#f8f9fa" 
            // : params.value > 16 && params.value < 18 ?  "#db9d9d"
            // : "#e70b0b" , // Conditional background
          }}
        >
          {params.value !== null ? params.value.toFixed(3).replace(".", ",") : null}
        </Box>
      ),
      //sortable: false
    },
    {
      field: 'threepm',
      headerName: '3PM',
      editable: false,
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 90,
      maxWidth: 90,
      align: 'center',
      headerAlign: 'center',
      //cellClassName: 'super-app-theme--cell',
      renderCell: (params) =>
      (
        <Box
          sx={{
            color: params.row.color_Threepm === null || params.row.color_Threepm === undefined ? "auto" : "black",
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: params.row.color_Threepm === null || params.row.color_Threepm === undefined ? "auto" : params.row.color_Threepm
            // value >= 25 ? "#079b00" 
            // : params.value > 20 && params.value < 25 ? "#5cd856" 
            // : params.value > 19 && params.value < 20 ? "#abe5a8" 
            // : params.value > 18 && params.value < 19 ? "#f8f9fa" 
            // : params.value > 16 && params.value < 18 ?  "#db9d9d"
            // : "#e70b0b" , // Conditional background
          }}
        >
          {params.value !== null ? params.value.toFixed(2).replace(".", ",") : null}
        </Box>
      ),
      //sortable: false
    },
    {
      field: 'threepa',
      headerName: '3PA',
      editable: false,
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 90,
      maxWidth: 90,
      align: 'center',
      headerAlign: 'center',
      //cellClassName: 'super-app-theme--cell',
      renderCell: (params) =>
      (
        <Box
          sx={{
            color: params.row.color_Threepa === null || params.row.color_Threepa === undefined ? "auto" : "black",
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: params.row.color_Threepa === null || params.row.color_Threepa === undefined ? "auto" : params.row.color_Threepa
            // value >= 25 ? "#079b00" 
            // : params.value > 20 && params.value < 25 ? "#5cd856" 
            // : params.value > 19 && params.value < 20 ? "#abe5a8" 
            // : params.value > 18 && params.value < 19 ? "#f8f9fa" 
            // : params.value > 16 && params.value < 18 ?  "#db9d9d"
            // : "#e70b0b" , // Conditional background
          }}
        >
          {params.value !== null ? params.value.toFixed(2).replace(".", ",") : null}
        </Box>
      ),
      //sortable: false
    },
    {
      field: 'threepmp',
      headerName: '3PM%',
      editable: false,
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 90,
      maxWidth: 90,
      align: 'center',
      headerAlign: 'center',
      //cellClassName: 'super-app-theme--cell',
      renderCell: (params) =>
      (
        <Box
          sx={{
            color: params.row.color_Threepmp === null || params.row.color_Threepmp === undefined ? "auto" : "black",
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: params.row.color_Threepmp === null || params.row.color_Threepmp === undefined ? "auto" : params.row.color_Threepmp
            // value >= 25 ? "#079b00" 
            // : params.value > 20 && params.value < 25 ? "#5cd856" 
            // : params.value > 19 && params.value < 20 ? "#abe5a8" 
            // : params.value > 18 && params.value < 19 ? "#f8f9fa" 
            // : params.value > 16 && params.value < 18 ?  "#db9d9d"
            // : "#e70b0b" , // Conditional background
          }}
        >
          {params.value !== null ? params.value.toFixed(3).replace(".", ",") : null}
        </Box>
      ),
      //sortable: false
    },
    {
      field: 'fte',
      headerName: 'FTE',
      editable: false,
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 90,
      maxWidth: 90,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) =>
      (
        <Box
          sx={{
            color: params.row.color_Fte === null || params.row.color_Fte === undefined ? "auto" : "black",
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: params.row.color_Fte === null || params.row.color_Fte === undefined ? "auto" : params.row.color_Fte
            // value >= 25 ? "#079b00" 
            // : params.value > 20 && params.value < 25 ? "#5cd856" 
            // : params.value > 19 && params.value < 20 ? "#abe5a8" 
            // : params.value > 18 && params.value < 19 ? "#f8f9fa" 
            // : params.value > 16 && params.value < 18 ?  "#db9d9d"
            // : "#e70b0b" , // Conditional background
          }}
        >
          {params.value !== null ? params.value.toFixed(2).replace(".", ",") : null}
        </Box>
      ),
      //sortable: false
    },
    {
      field: 'fge',
      headerName: 'FGE',
      editable: false,
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 90,
      maxWidth: 90,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) =>
      (
        <Box
          sx={{
            color: params.row.color_Fge === null || params.row.color_Fge === undefined ? "auto" : "black",
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: params.row.color_Fge === null || params.row.color_Fge === undefined ? "auto" : params.row.color_Fge === null ? "auto" : params.row.color
            // value >= 25 ? "#079b00" 
            // : params.value > 20 && params.value < 25 ? "#5cd856" 
            // : params.value > 19 && params.value < 20 ? "#abe5a8" 
            // : params.value > 18 && params.value < 19 ? "#f8f9fa" 
            // : params.value > 16 && params.value < 18 ?  "#db9d9d"
            // : "#e70b0b" , // Conditional background
          }}
        >
          {params.value !== null ? params.value.toFixed(2).replace(".", ",") : null}
        </Box>
      ),
      //sortable: false
    },
    {
      field: 'threepe',
      headerName: '3PE',
      editable: false,
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 90,
      maxWidth: 90,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) =>
      (
        <Box
          sx={{
            color: params.row.color_Threepe === null || params.row.color_Threepe === undefined ? "auto" : "black",
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: params.row.color_Threepe === null || params.row.color_Threepe === undefined ? "auto" : params.row.color_Threepe
            // value >= 25 ? "#079b00" 
            // : params.value > 20 && params.value < 25 ? "#5cd856" 
            // : params.value > 19 && params.value < 20 ? "#abe5a8" 
            // : params.value > 18 && params.value < 19 ? "#f8f9fa" 
            // : params.value > 16 && params.value < 18 ?  "#db9d9d"
            // : "#e70b0b" , // Conditional background
          }}
        >
          {params.value !== null ? params.value.toFixed(2).replace(".", ",") : null}
        </Box>
      ),
      //sortable: false
    },
    {
      field: 'stocks',
      headerName: 'STOCKS',
      editable: false,
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 90,
      maxWidth: 90,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) =>
      (
        <Box
          sx={{
            color: params.row.color_Stocks === null || params.row.color_Stocks === undefined ? "auto" : "black",
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: params.row.color_Stocks === null || params.row.color_Stocks === undefined ? "auto" : params.row.color_Stocks
            // value >= 25 ? "#079b00" 
            // : params.value > 20 && params.value < 25 ? "#5cd856" 
            // : params.value > 19 && params.value < 20 ? "#abe5a8" 
            // : params.value > 18 && params.value < 19 ? "#f8f9fa" 
            // : params.value > 16 && params.value < 18 ?  "#db9d9d"
            // : "#e70b0b" , // Conditional background
          }}
        >
          {params.value !== null ? params.value.toFixed(2).replace(".", ",") : null}
        </Box>
      ),
      //sortable: false
    },
    {
      field: 'peso_Total_Jogador',
      headerName: 'TOTAL',
      editable: false,
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 90,
      maxWidth: 90,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => params.value !== null ? params.value.toFixed(3).replace(".", ",") : null,
      //sortable: false
    },
    {
      field: 'peso_Minutos_Jogador',
      headerName: 'PESO MIN',
      editable: false,
      flex: 1,
      minWidth: 110,
      maxWidth: 110,
      headerClassName: 'super-app-theme--header',
      align: 'center',
      headerAlign: 'center',
      //cellClassName: 'super-app-theme--cell',
      renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : null,
      //sortable: false
    },
  ];

  const CarregarDadosExportJogadores = async () => {
    setIsLoading(true);
    //let resultado: IListaDadosMediaJogadores[] = estatisticasRows ;

    let dadosFiltros: IDadosFiltrosJogadores = {
      codigoLiga: Number(codigoLiga),
      codigoTemporada: temporadaFiltro,
      codigoJogador: selectedIdComplete === 0 ? null : selectedIdComplete,
      codigoFranquiaLiga: codigoFranquiaLigaFiltro === 0 ? null : codigoFranquiaLigaFiltro,
      codigoFranquiaNBA: codigoFranquiaNbaFiltro === 0 ? null : codigoFranquiaNbaFiltro,
      posicao: posicaoFiltro === "" || posicaoFiltro === "0" ? null : posicaoFiltro,
      codigoTemporadaCalouro: temporadaCalouroFiltro,
      dataInicio: dataInicioFiltro,
      dataFim: dataFimFiltro,
      quantidadeDeJogos: quantidadeJogosFiltro,
      ast: chkAst,
      peso_AST: handleConverteValorPeso(xAst),//
      blk: chkBlk,
      peso_BLK: handleConverteValorPeso(xBlk),// 
      pf: chkFaltas,
      peso_PF: handleConverteValorPeso(xFaltas),
      fgm: chkFgm,
      peso_FGM: handleConverteValorPeso(xFgm),
      fga: chkFga,
      peso_FGA: handleConverteValorPeso(xFga),
      fge: chkFge,
      peso_FGE: handleConverteValorPeso(xFge),
      ftm: chkFtm,
      peso_FTM: handleConverteValorPeso(xFtm),
      fte: chkFte,
      peso_FTE: handleConverteValorPeso(xFte),
      fta: chkFta,
      peso_FTA: handleConverteValorPeso(xFta),
      mplu: chkMinPlus,
      peso_MPLU: handleConverteValorPeso(xMinPlus),
      pts: chkPts,
      peso_PTS: handleConverteValorPeso(xPts),
      reb: chkTReb,
      peso_REB: handleConverteValorPeso(xTReb),
      dreb: chkDReb,
      peso_DREB: handleConverteValorPeso(xDReb),
      oreb: chkOReb,
      peso_OREB: handleConverteValorPeso(xOReb),
      stl: chkStl,
      peso_STL: handleConverteValorPeso(xStl),
      threepm: chk3pm,
      peso_THREEPM: handleConverteValorPeso(x3pm),
      threepe: chk3pe,
      peso_THREEPE: handleConverteValorPeso(x3pe),
      threepa: chk3pa,
      peso_THREEPA: handleConverteValorPeso(x3pa),
      tor: chkTurnovers,
      peso_TO: handleConverteValorPeso(xTurnovers),
      stocks: chkStocks,
      peso_STOCKS: handleConverteValorPeso(xStocks),
      fgmp: chkFgmp,
      peso_FGMP: handleConverteValorPeso(xFgmp),
      ftmp: chkFtmp,
      peso_FTMP: handleConverteValorPeso(xFtmp),
      threepmp: chk3pmp,
      peso_THREEPMP: handleConverteValorPeso(x3pmp),
    }

    if (tipoFiltro === 1) {
      await EstatisticasService.getMediaJogadoresNBA(dadosFiltros)
        .then((result) => {
          const lstDados = result.dado;
          setEstatisticasRows(lstDados);
          let resultado = JSON.parse(JSON.stringify(lstDados))
          for (var key in resultado) {
            if (resultado[key].dreb === null || resultado[key].dreb === 0) {
              delete resultado[key].dreb;
            }
            else {
              resultado[key].dreb = Number(resultado[key].dreb?.toFixed(2));
            }
            if (resultado[key].fga === null) {
              delete resultado[key].fga;
            }
            else {
              resultado[key].fga = Number(resultado[key].fga?.toFixed(2));
            }
            if (resultado[key].fge === null) {
              delete resultado[key].fge;
            }
            else {
              resultado[key].fge = Number(resultado[key].fge?.toFixed(2));
            }
            if (resultado[key].fgm === null) {
              delete resultado[key].fgm;
            }
            else {
              resultado[key].fgm = Number(resultado[key].fgm?.toFixed(2));
            }
            if (resultado[key].fgmp === null) {
              delete resultado[key].fgmp;
            }
            else {
              resultado[key].fgmp = Number(resultado[key].fgmp?.toFixed(3));
            }
            if (resultado[key].fta === null) {
              delete resultado[key].fta;
            }
            else {
              resultado[key].fta = Number(resultado[key].fta?.toFixed(2));
            }
            if (resultado[key].fte === null) {
              delete resultado[key].fte;
            }
            else {
              resultado[key].fte = Number(resultado[key].fte?.toFixed(2));
            }
            if (resultado[key].ftm === null) {
              delete resultado[key].ftm;
            }
            else {
              resultado[key].ftm = Number(resultado[key].ftm?.toFixed(2));
            }
            if (resultado[key].ftmp === null) {
              delete resultado[key].ftmp;
            }
            else {
              resultado[key].ftmp = Number(resultado[key].ftmp?.toFixed(2));
            }
            if (resultado[key].mplu === null) {
              delete resultado[key].mplu;
            }
            else {
              resultado[key].mplu = Number(resultado[key].mplu?.toFixed(2));
            }
            if (resultado[key].oreb === null) {
              delete resultado[key].oreb;
            }
            else {
              resultado[key].oreb = Number(resultado[key].oreb?.toFixed(2));
            }
            if (resultado[key].peso_Total_Jogador === null) {
              delete resultado[key].peso_Total_Jogador;
            }
            else {
              resultado[key].peso_Total_Jogador = Number(resultado[key].peso_Total_Jogador?.toFixed(3));
            }
            if (resultado[key].pf === null) {
              delete resultado[key].pf;
            }
            else {
              resultado[key].pf = Number(resultado[key].pf?.toFixed(2));
            }
            if (resultado[key].pts === null) {
              delete resultado[key].pts;
            }
            else {
              resultado[key].pts = Number(resultado[key].pts?.toFixed(2));
            }
            if (resultado[key].quantidade_Jogos === null) {
              delete resultado[key].quantidade_Jogos;
            }
            if (resultado[key].reb === null) {
              delete resultado[key].reb;
            }
            else {
              resultado[key].reb = Number(resultado[key].reb?.toFixed(2));
            }
            if (resultado[key].stocks === null) {
              delete resultado[key].stocks;
            }
            else {
              resultado[key].stocks = Number(resultado[key].stocks?.toFixed(2));
            }
            if (resultado[key].threepa === null) {
              delete resultado[key].threepa;
            }
            else {
              resultado[key].threepa = Number(resultado[key].threepa?.toFixed(2));
            }
            if (resultado[key].threepe === null) {
              delete resultado[key].threepe;
            }
            else {
              resultado[key].threepe = Number(resultado[key].threepe?.toFixed(2));
            }
            if (resultado[key].threepm === null) {
              delete resultado[key].threepm;
            }
            else {
              resultado[key].threepm = Number(resultado[key].threepm?.toFixed(3));
            }
            if (resultado[key].threepmp === null) {
              delete resultado[key].threepmp;
            }
            else {
              resultado[key].threepmp = Number(resultado[key].threepmp?.toFixed(3));
            }
            if (resultado[key].blk === null) {
              delete resultado[key].blk;
            }
            else {
              resultado[key].blk = Number(resultado[key].blk?.toFixed(2));
            }
            if (resultado[key].ast === null) {
              delete resultado[key].ast;
            }
            else {
              resultado[key].ast = Number(resultado[key].ast?.toFixed(2));
            }
            if (resultado[key].stl === null) {
              delete resultado[key].stl;
            }
            else {
              resultado[key].stl = Number(resultado[key].stl?.toFixed(2));
            }
            if (resultado[key].to === null) {
              delete resultado[key].to;
            }
            else {
              resultado[key].to = Number(resultado[key].to?.toFixed(2));
            }
            if (resultado[key].min === null) {
              delete resultado[key].min;
            }
            else {
              resultado[key].min = Number(resultado[key].min?.toFixed(2));
            }
            if (resultado[key].peso_Minutos_Jogador === null) {
              delete resultado[key].peso_Minutos_Jogador;
            }
            else {
              resultado[key].peso_Minutos_Jogador = Number(resultado[key].peso_Minutos_Jogador?.toFixed(2));
            }
            delete resultado[key].foto;

            delete resultado[key].fgM_Informativo;
            delete resultado[key].fgA_Informativo;
            delete resultado[key].ftA_Informativo;
            delete resultado[key].ftM_Informativo;
            delete resultado[key].threepA_Informativo;
            delete resultado[key].threepM_Informativo;
            delete resultado[key].setimo_Homem;
            delete resultado[key].ordem;
            delete resultado[key].codigo_NBA;
            delete resultado[key].codigo;


            //delete resultado[key].codigo;


          }
          exportToExcel(resultado);
          setIsLoading(false);
          setRemoveLoading(true);
        })
        .catch((errors) => {
          setShowModalMensagem(true);
          setRemoveLoading(true);
          if (errors.response) {
            if (errors.response.status === 401) {
              setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: "Sessão expirada!",
                display: "none",
                titulo: "Atenção"
              });
              logout();
              setRedirecionar("0");
              return;
            }

            setDadosModalMensagem({
              acao: true,
              label: "",
              tipo: "error",
              mensagem: errors.response.data.mensagem,
              display: "none",
              titulo: "Atenção"
            });
            return;
          }

          setDadosModalMensagem({
            acao: true,
            label: "",
            tipo: "error",
            mensagem: "Não foi possível carregar os dados! Tente novamente mais tarde e caso o problema persista, favor entrar em contato com a TI.",
            display: "none",
            titulo: "Atenção"
          });

          setRedirecionar(`/usuario/liga/${codLocal}`);
          return;
        });
    }
    else if (tipoFiltro === 2) {
      await EstatisticasService.getMediaJogadores(dadosFiltros)
        .then((result) => {
          const lstDados = result.dado;
          setEstatisticasRows(lstDados);
          let resultado = JSON.parse(JSON.stringify(lstDados))
          for (var key in resultado) {
            if (resultado[key].dreb === null || resultado[key].dreb === 0) {
              delete resultado[key].dreb;
            }
            else {
              resultado[key].dreb = Number(resultado[key].dreb?.toFixed(2));
            }
            if (resultado[key].fga === null) {
              delete resultado[key].fga;
            }
            else {
              resultado[key].fga = Number(resultado[key].fga?.toFixed(2));
            }
            if (resultado[key].fge === null) {
              delete resultado[key].fge;
            }
            else {
              resultado[key].fge = Number(resultado[key].fge?.toFixed(2));
            }
            if (resultado[key].fgm === null) {
              delete resultado[key].fgm;
            }
            else {
              resultado[key].fgm = Number(resultado[key].fgm?.toFixed(2));
            }
            if (resultado[key].fgmp === null) {
              delete resultado[key].fgmp;
            }
            else {
              resultado[key].fgmp = Number(resultado[key].fgmp?.toFixed(3));
            }
            if (resultado[key].fta === null) {
              delete resultado[key].fta;
            }
            else {
              resultado[key].fta = Number(resultado[key].fta?.toFixed(2));
            }
            if (resultado[key].fte === null) {
              delete resultado[key].fte;
            }
            else {
              resultado[key].fte = Number(resultado[key].fte?.toFixed(2));
            }
            if (resultado[key].ftm === null) {
              delete resultado[key].ftm;
            }
            else {
              resultado[key].ftm = Number(resultado[key].ftm?.toFixed(2));
            }
            if (resultado[key].ftmp === null) {
              delete resultado[key].ftmp;
            }
            else {
              resultado[key].ftmp = Number(resultado[key].ftmp?.toFixed(2));
            }
            if (resultado[key].mplu === null) {
              delete resultado[key].mplu;
            }
            else {
              resultado[key].mplu = Number(resultado[key].mplu?.toFixed(2));
            }
            if (resultado[key].oreb === null) {
              delete resultado[key].oreb;
            }
            else {
              resultado[key].oreb = Number(resultado[key].oreb?.toFixed(2));
            }
            if (resultado[key].peso_Total_Jogador === null) {
              delete resultado[key].peso_Total_Jogador;
            }
            else {
              resultado[key].peso_Total_Jogador = Number(resultado[key].peso_Total_Jogador?.toFixed(3));
            }
            if (resultado[key].pf === null) {
              delete resultado[key].pf;
            }
            else {
              resultado[key].pf = Number(resultado[key].pf?.toFixed(2));
            }
            if (resultado[key].pts === null) {
              delete resultado[key].pts;
            }
            else {
              resultado[key].pts = Number(resultado[key].pts?.toFixed(2));
            }
            if (resultado[key].quantidade_Jogos === null) {
              delete resultado[key].quantidade_Jogos;
            }
            if (resultado[key].reb === null) {
              delete resultado[key].reb;
            }
            else {
              resultado[key].reb = Number(resultado[key].reb?.toFixed(2));
            }
            if (resultado[key].stocks === null) {
              delete resultado[key].stocks;
            }
            else {
              resultado[key].stocks = Number(resultado[key].stocks?.toFixed(2));
            }
            if (resultado[key].threepa === null) {
              delete resultado[key].threepa;
            }
            else {
              resultado[key].threepa = Number(resultado[key].threepa?.toFixed(2));
            }
            if (resultado[key].threepe === null) {
              delete resultado[key].threepe;
            }
            else {
              resultado[key].threepe = Number(resultado[key].threepe?.toFixed(2));
            }
            if (resultado[key].threepm === null) {
              delete resultado[key].threepm;
            }
            else {
              resultado[key].threepm = Number(resultado[key].threepm?.toFixed(3));
            }
            if (resultado[key].threepmp === null) {
              delete resultado[key].threepmp;
            }
            else {
              resultado[key].threepmp = Number(resultado[key].threepmp?.toFixed(3));
            }
            if (resultado[key].blk === null) {
              delete resultado[key].blk;
            }
            else {
              resultado[key].blk = Number(resultado[key].blk?.toFixed(2));
            }
            if (resultado[key].ast === null) {
              delete resultado[key].ast;
            }
            else {
              resultado[key].ast = Number(resultado[key].ast?.toFixed(2));
            }
            if (resultado[key].stl === null) {
              delete resultado[key].stl;
            }
            else {
              resultado[key].stl = Number(resultado[key].stl?.toFixed(2));
            }
            if (resultado[key].to === null) {
              delete resultado[key].to;
            }
            else {
              resultado[key].to = Number(resultado[key].to?.toFixed(2));
            }
            if (resultado[key].min === null) {
              delete resultado[key].min;
            }
            else {
              resultado[key].min = Number(resultado[key].min?.toFixed(2));
            }
            if (resultado[key].peso_Minutos_Jogador === null) {
              delete resultado[key].peso_Minutos_Jogador;
            }
            else {
              resultado[key].peso_Minutos_Jogador = Number(resultado[key].peso_Minutos_Jogador?.toFixed(2));
            }
            delete resultado[key].foto;

            delete resultado[key].fgM_Informativo;
            delete resultado[key].fgA_Informativo;
            delete resultado[key].ftA_Informativo;
            delete resultado[key].ftM_Informativo;
            delete resultado[key].threepA_Informativo;
            delete resultado[key].threepM_Informativo;
            delete resultado[key].setimo_Homem;
            delete resultado[key].ordem;
            delete resultado[key].codigo_NBA;
            delete resultado[key].codigo;


            //delete resultado[key].codigo;


          }
          exportToExcel(resultado);
          setIsLoading(false);
          setRemoveLoading(true);
        })
        .catch((errors) => {
          setShowModalMensagem(true);
          setIsLoading(false);
          setRemoveLoading(true);
          if (errors.response) {
            if (errors.response.status === 401) {
              setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: "Sessão expirada!",
                display: "none",
                titulo: "Atenção"
              });
              logout();
              setRedirecionar("0");
              return;
            }

            setDadosModalMensagem({
              acao: true,
              label: "",
              tipo: "error",
              mensagem: errors.response.data.mensagem,
              display: "none",
              titulo: "Atenção"
            });
            return;
          }

          setDadosModalMensagem({
            acao: true,
            label: "",
            tipo: "error",
            mensagem: "Não foi possível carregar os dados! Tente novamente mais tarde e caso o problema persista, favor entrar em contato com a TI.",
            display: "none",
            titulo: "Atenção"
          });

          setRedirecionar(`/usuario/liga/${codLocal}`);
          return;
        });
    }


  }

  const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml,sheet;charser=UTF-8";
  const fileExtension = ".xlsx";
  const exportToExcel = async (dados: IListaDadosMediaJogadores[]) => {
    const ws = XLSX.utils.json_to_sheet(dados);
    const wb = { Sheets: { "data": ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, `Jogadores_${tiposFiltro.find(f => f.codigo === tipoFiltro)?.label}.${fileExtension}`);
    setIsLoading(false);
  }

  const handleConverteValorPeso = (codigo: number) => {

    let valor = 0;
    if (codigo === 1)
      return 3
    else if (codigo === 2)
      return 2.5
    else if (codigo === 3)
      return 2
    else if (codigo === 4)
      return 1.5
    else if (codigo === 5)
      return 1.25
    else if (codigo === 6)
      return 1
    else if (codigo === 7)
      return 0.75
    else
      return 0.5

  }

  return (
    <LayoutBaseDePagina
      titulo={`Média Jogadores - ${dadosLiga?.nome}`}
      showLogoImg={showImagemFranquia}
      barraDeFerramentas={<FerramentasDaListagem
        textoBotaoNovo="Nova"
        mostrarBotaoNovo={false}
        mostrarInputBusca={false}
        aoMudarTextoDeBusca={texto => SetSearchParams({ busca: texto, pagina: "1" }, { replace: true })}
      />}>

      {showModalEvent && <DialogEvent dados={dadosModalEvent} isModalVisible={showModalEvent} onBackClickClose={toggleModalEvent} />}
      {showModalMensagem && <DialogMensagem dados={dadosModalMensagem} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
      <Box margin={1} display="flex" component={Paper} variant="outlined"  >
        <Grid container size={{ xs: 12, sm: 12 }} sx={{ width: "100%" }}>
          <Grid container size={{ xs: 12, sm: 12 }} direction="column" padding={2} spacing={2} >
            <Grid container size={{ xs: 12, sm: 12 }} spacing={1}>
              <Grid size={{ xs: 12, sm: 12 }} >
                <Typography variant="h6"> Média dos Jogadores </Typography>
                <hr />
              </Grid>
              <Grid container size={{ xs: 12, sm: 12 }} display="flex" justifyContent="initial">
                <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                  <FormControl fullWidth disabled={isLoading}>
                    <InputLabel id="demo-simple-select-label">Temporadas</InputLabel>
                    <Select
                      variant="outlined"
                      native={false}
                      value={temporadaFiltro}
                      label="Temporadas"
                      onChange={handleSelectedTemporada}
                    >
                      <MenuItem value={0}>Selecione</MenuItem>
                      {
                        lstTemporadas.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                      }
                    </Select>
                  </FormControl >
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 6 }} display="flex" justifyContent="center">
                  <FormControl>
                    <FormLabel>Tipo</FormLabel>
                    <MuiRadioGroup
                      row
                      name="tipo"
                      value={tipoFiltro}
                      onChange={handleChangeTipo}
                    >
                      {
                        tiposFiltro.map(item => (<FormControlLabel key={item.codigo} value={item.codigo} control={<Radio />} label={item.label} />))
                      }
                    </MuiRadioGroup>
                  </FormControl >
                </Grid>
                <Grid size={{ xs: 12, sm: 3 }} display={"flex"} justifyContent="flex-end">
                  {estatisticasRows.length > 0 && (
                    <Tooltip title="Exportar Time">
                      <LoadingButton variant="contained"
                        onClick={(e) => CarregarDadosExportJogadores()} color="primary"
                        style={{ cursor: "pointer", height: "48px" }}
                        endIcon={<GridSaveAltIcon />}
                        loading={isLoading}
                        loadingPosition="end"
                      >
                        Exportar Jogadores
                      </LoadingButton >
                    </Tooltip>
                  )}
                </Grid>
              </Grid>
              <Grid container size={{ xs: 12, sm: 12 }} spacing={2} paddingTop={2}>
                <Grid size={{ xs: 12, sm: 3, md: 3 }} paddingBottom={2}>
                  <Autocomplete
                    openText="Abrir"
                    closeText="Fechar"
                    noOptionsText="Sem opções"
                    loadingText="Carregando..."
                    options={opcoesAutoCompleteJogador}
                    loading={isLoading}
                    disabled={isLoading}
                    value={autoCompleteSelectedOption}
                    size={UtilidadeService.isMobile() ? "small" : "medium"}
                    onChange={(event, newValue) => { setSelectedIdComplete(newValue?.codigo); }}
                    popupIcon={isLoading ? <CircularProgress size={UtilidadeService.isMobile() ? 16 : 28} /> : undefined}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Jogador"
                        slotProps={{
                          inputLabel: {
                            style: {
                              fontSize: UtilidadeService.isMobile() ? 13 : 16
                            }
                          }
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid size={{ xs: 12, sm: 2, md: 2 }} >
                  <FormControl fullWidth disabled={isLoading}>
                    <InputLabel id="demo-simple-select-label">Franquia NBA</InputLabel>
                    <Select
                      variant="outlined"
                      value={codigoFranquiaNbaFiltro}
                      label="Franquia NBA"
                      onChange={(e) => {carregarDadosMediasJogadores(Number(codigoLiga), temporadaFiltro, Number(e.target.value), false, null, 6, [],true, false); setCodigoFranquiaNbaFiltro(Number(e.target.value))}}
                    >
                      <MenuItem value={0}>Todas</MenuItem>
                      {
                        lstFranquiasNBA.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                      }

                    </Select>
                  </FormControl >
                </Grid>
                <Grid size={{ xs: 12, sm: 2, md: 2 }} >
                  <FormControl fullWidth disabled={isLoading}>
                    <InputLabel id="demo-simple-select-label">Franquia Liga</InputLabel>
                    <Select
                      variant="outlined"
                      value={codigoFranquiaLigaFiltro}
                      label="Franquia Liga"
                      onChange={(e) => setCodigoFranquiaLigaFiltro(Number(e.target.value))}
                    >
                      <MenuItem value={0}>Todas</MenuItem>
                      <MenuItem value={-1}>Sem Franquia</MenuItem>
                      {
                        lstFranquias.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                      }

                    </Select>
                  </FormControl >
                </Grid>
                <Grid size={{ xs: 12, sm: 2, md: 2 }} >
                  <FormControl fullWidth disabled={isLoading}>
                    <InputLabel id="demo-simple-select-label">Posição</InputLabel>
                    <Select
                      variant="outlined"
                      value={posicaoFiltro}
                      label="Posição"
                      onChange={(e) => setPosicaoFiltro(e.target.value)}
                      defaultValue={"0"}
                    >
                      <MenuItem value={"0"}>Todas</MenuItem>
                      {
                        lstPosicoes.map(item => (<MenuItem key={item.label} value={item.label}>{item.label}</MenuItem>))
                      }

                    </Select>
                  </FormControl >
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                  <FormControl fullWidth disabled={isLoading}>
                    <InputLabel id="filtro">Temporada Calouro</InputLabel>
                    <Select
                      variant="outlined"
                      native={false}
                      label="Temporada Calouro"
                      value={temporadaCalouroFiltro}
                      onChange={(e) => setTemporadaCalouroFiltro(Number(e.target.value))}
                    >
                      <MenuItem value={0}>Selecione</MenuItem>
                      {
                        lstTemporadas.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                      }
                    </Select>
                  </FormControl >
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                  <TextField
                    fullWidth
                    type="date"
                    name="dataInicioFiltro"
                    style={{ colorScheme: "auto" }}
                    disabled={isLoading}
                    label="Data Início"
                    value={dataInicioFiltro}
                    onChange={(e) => setDataInicioFiltro(e.target.value)}
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      }
                    }}
                  />
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                  <TextField
                    fullWidth
                    type="date"
                    name="dataFimFiltro"
                    disabled={isLoading}
                    label="Data Fim"
                    value={dataFimFiltro}
                    onChange={(e) => setDataFimFiltro(e.target.value)}
                    slotProps={{
                      inputLabel: {

                        shrink: true,
                      },
                      input: {
                        color: "primary"
                      }
                    }}
                  />
                </Grid>
                <Grid size={{ xs: 12, sm: 2, md: 2 }} >
                  <FormControl fullWidth disabled={isLoading}>
                    <InputLabel id="filtro">Quantidade Jogos</InputLabel>
                    <Select
                      variant="outlined"
                      native={false}
                      label="Quantidade Jogos"
                      value={quantidadeJogosFiltro}
                      onChange={(e) => setQuantidadeJogosFiltro(Number(e.target.value))}
                    >
                      <MenuItem value={0}>Selecione</MenuItem>
                      {
                        quantidadeDeJogos.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                      }
                    </Select>
                  </FormControl >
                </Grid>
                <Grid size={{ xs: 6, sm: 2, md: 2 }} display={"flex"} justifyContent={"end"} alignSelf={"end"}>
                  <Button
                    color="primary"
                    variant="contained"
                    disableElevation
                    onClick={() => carregarDadosMediasJogadores(Number(codigoLiga), temporadaFiltro, tipoFiltro, false, null, 6, [], false, false)}
                    startIcon={<Icon>change_circle</Icon>}
                  >
                    Pesquisar
                  </Button>
                </Grid>
                <Grid container size={{ xs: 12, sm: 12, md: 12 }} margin={1} padding={UtilidadeService.isMobile() ? 2 : 1}  >
                  <Grid container size={{ xs: 3, sm: 2, md: 2 }} padding={0} display={"flex"} justifyContent={"center"} >
                    <Grid size={12} padding={0} display={"flex"} justifyContent={"center"}>
                      <FormControlLabel
                        key="chkFgm"
                        control={(
                          <Checkbox
                            name="FGM"
                            checked={chkFgm}
                            onChange={(e) => { carregarDadosMediasJogadores(Number(codigoLiga), temporadaFiltro, tipoFiltro, false, "fgm", xFgm, [], false, e.target.checked); setChkFgm(e.target.checked) }}
                            //defaultValue={eval(`telegram${index}`)}
                            disabled={isLoading}
                          />
                        )}
                        label="FGM"
                      />
                    </Grid>
                    <Grid size={12} padding={0} display={"flex"} justifyContent={"center"}>
                      <FormControl fullWidth disabled={isLoading || !chkFgm}>
                        <Select
                          variant="outlined"
                          native={false}
                          label="XFgm"
                          value={xFgm}
                          onChange={(e) => { carregarDadosMediasJogadores(Number(codigoLiga), temporadaFiltro, tipoFiltro, false, "fgm", Number(e.target.value), [], false, chkFgm); setXFgm(Number(e.target.value)) }}
                        >
                          <MenuItem value={0}>Selecione</MenuItem>
                          {
                            porcentagemStats.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                          }
                        </Select>
                      </FormControl >
                    </Grid>
                  </Grid>
                  <Grid container size={{ xs: 3, sm: 2, md: 2 }} padding={0} display={"flex"} justifyContent={"center"} >
                    <Grid size={12} padding={0} display={"flex"} justifyContent={"center"}>
                      <FormControlLabel
                        key="chkFtm"
                        control={(
                          <Checkbox
                            name="FTM"
                            checked={chkFtm}
                            onChange={(e) => { carregarDadosMediasJogadores(Number(codigoLiga), temporadaFiltro, tipoFiltro, false, "ftm", xFtm, [], false, e.target.checked); setChkFtm(e.target.checked) }}
                            //defaultValue={eval(`telegram${index}`)}
                            disabled={isLoading}
                          />
                        )}
                        label="FTM"
                      />
                    </Grid>
                    <Grid size={12} padding={0} display={"flex"} justifyContent={"center"}>
                      <FormControl fullWidth disabled={isLoading || !chkFtm}>
                        <Select
                          variant="outlined"
                          native={false}
                          label="XFtm"
                          value={xFtm}
                          onChange={(e) => { carregarDadosMediasJogadores(Number(codigoLiga), temporadaFiltro, tipoFiltro, false, "ftm", Number(e.target.value), [], false, chkFtm); setXFtm(Number(e.target.value)) }}
                        >
                          <MenuItem value={0}>Selecione</MenuItem>
                          {
                            porcentagemStats.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                          }
                        </Select>
                      </FormControl >
                    </Grid>
                  </Grid>
                  <Grid container size={{ xs: 3, sm: 2, md: 2 }} padding={0} display={"flex"} justifyContent={"center"} >
                    <Grid size={12} padding={0} display={"flex"} justifyContent={"center"}>
                      <FormControlLabel
                        key="chk3pm"
                        control={(
                          <Checkbox
                            name="3PM"
                            checked={chk3pm}
                            onChange={(e) => { carregarDadosMediasJogadores(Number(codigoLiga), temporadaFiltro, tipoFiltro, false, "threepm", x3pm, [], false, e.target.checked); setChk3pm(e.target.checked) }}
                            //defaultValue={eval(`telegram${index}`)}
                            disabled={isLoading}
                          />
                        )}
                        label="3PM"
                      />
                    </Grid>
                    <Grid size={12} padding={0} display={"flex"} justifyContent={"center"}>
                      <FormControl fullWidth disabled={isLoading || !chk3pm}>
                        <Select
                          variant="outlined"
                          native={false}
                          label="X3pm"
                          value={x3pm}
                          onChange={(e) => { carregarDadosMediasJogadores(Number(codigoLiga), temporadaFiltro, tipoFiltro, false, "threepm", Number(e.target.value), [], false, chk3pm); setX3pm(Number(e.target.value)) }}
                        >
                          <MenuItem value={0}>Selecione</MenuItem>
                          {
                            porcentagemStats.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                          }
                        </Select>
                      </FormControl >
                    </Grid>
                  </Grid>
                  <Grid container size={{ xs: 3, sm: 2, md: 2 }} padding={0} display={"flex"} justifyContent={"center"} >
                    <Grid size={12} padding={0} display={"flex"} justifyContent={"center"}>
                      <FormControlLabel
                        key="chk3pmp"
                        control={(
                          <Checkbox
                            name="3P%"
                            checked={chk3pmp}
                            onChange={(e) => { carregarDadosMediasJogadores(Number(codigoLiga), temporadaFiltro, tipoFiltro, false, "threepmp", x3pmp, [], false, e.target.checked); setChk3pmp(e.target.checked) }}
                            //defaultValue={eval(`telegram${index}`)}
                            disabled={isLoading}
                          />
                        )}
                        label="3PM%"
                      />
                    </Grid>
                    <Grid size={12} padding={0} display={"flex"} justifyContent={"center"}>
                      <FormControl fullWidth disabled={isLoading || !chk3pmp}>
                        <Select
                          variant="outlined"
                          native={false}
                          label="X3pmp"
                          value={x3pmp}
                          onChange={(e) => { carregarDadosMediasJogadores(Number(codigoLiga), temporadaFiltro, tipoFiltro, false, "threepmp", Number(e.target.value), [], false, chk3pmp); setX3pmp(Number(e.target.value)) }}
                        >
                          <MenuItem value={0}>Selecione</MenuItem>
                          {
                            porcentagemStats.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                          }
                        </Select>
                      </FormControl >
                    </Grid>
                  </Grid>
                  <Grid container size={{ xs: 3, sm: 2, md: 2 }} padding={0} display={"flex"} justifyContent={"center"} >
                    <Grid size={12} padding={0} display={"flex"} justifyContent={"center"}>
                      <FormControlLabel
                        key="chkPts"
                        control={(
                          <Checkbox
                            name="PTS"
                            checked={chkPts}
                            onChange={(e) => { carregarDadosMediasJogadores(Number(codigoLiga), temporadaFiltro, tipoFiltro, false, "pts", xPts, [], false, e.target.checked); setChkPts(e.target.checked) }}
                            //defaultValue={eval(`telegram${index}`)}
                            disabled={isLoading}
                          />
                        )}
                        label="PTS"
                      />
                    </Grid>
                    <Grid size={12} padding={0} display={"flex"} justifyContent={"center"}>
                      <FormControl fullWidth disabled={isLoading || !chkPts}>
                        <Select
                          variant="outlined"
                          native={false}
                          label="XPts"
                          value={xPts}
                          onChange={(e) => { carregarDadosMediasJogadores(Number(codigoLiga), temporadaFiltro, tipoFiltro, false, "pts", Number(e.target.value), [], false, chkPts); setXPts(Number(e.target.value)) }}
                        >
                          <MenuItem value={0}>Selecione</MenuItem>
                          {
                            porcentagemStats.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                          }
                        </Select>
                      </FormControl >
                    </Grid>
                  </Grid>
                  <Grid container size={{ xs: 3, sm: 2, md: 2 }} padding={0} display={"flex"} justifyContent={"center"} >
                    <Grid size={12} padding={0} display={"flex"} justifyContent={"center"}>
                      <FormControlLabel
                        key="chkDReb"
                        control={(
                          <Checkbox
                            name="DReb"
                            checked={chkDReb}
                            onChange={(e) => { carregarDadosMediasJogadores(Number(codigoLiga), temporadaFiltro, tipoFiltro, false, "dreb", xDReb, [], false, e.target.checked); setChkDReb(e.target.checked) }}
                            //defaultValue={eval(`telegram${index}`)}
                            disabled={isLoading}
                          />
                        )}
                        label="DREB"
                      />
                    </Grid>
                    <Grid size={12} padding={0} display={"flex"} justifyContent={"center"}>
                      <FormControl fullWidth disabled={isLoading || !chkDReb}>
                        <Select
                          variant="outlined"
                          native={false}
                          label="XDReb"
                          value={xDReb}
                          onChange={(e) => { carregarDadosMediasJogadores(Number(codigoLiga), temporadaFiltro, tipoFiltro, false, "dreb", Number(e.target.value), [], false, chkDReb); setXDReb(Number(e.target.value)) }}
                        >
                          <MenuItem value={0}>Selecione</MenuItem>
                          {
                            porcentagemStats.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                          }
                        </Select>
                      </FormControl >
                    </Grid>
                  </Grid>
                  <Grid container size={{ xs: 3, sm: 2, md: 2 }} padding={0} display={"flex"} justifyContent={"center"} >
                    <Grid size={12} padding={0} display={"flex"} justifyContent={"center"}>
                      <FormControlLabel
                        key="chkOReb"
                        control={(
                          <Checkbox
                            name="OReb"
                            checked={chkOReb}
                            onChange={(e) => { carregarDadosMediasJogadores(Number(codigoLiga), temporadaFiltro, tipoFiltro, false, "oreb", xOReb, [], false, e.target.checked); setChkOReb(e.target.checked) }}
                            //defaultValue={eval(`telegram${index}`)}
                            disabled={isLoading}
                          />
                        )}
                        label="OREB"
                      />
                    </Grid>
                    <Grid size={12} padding={0} display={"flex"} justifyContent={"center"}>
                      <FormControl fullWidth disabled={isLoading || !chkOReb}>
                        <Select
                          variant="outlined"
                          native={false}
                          label="XOReb"

                          value={xOReb}
                          onChange={(e) => { carregarDadosMediasJogadores(Number(codigoLiga), temporadaFiltro, tipoFiltro, false, "oreb", Number(e.target.value), [], false, chkOReb); setXOReb(Number(e.target.value)) }}
                        >
                          <MenuItem value={0}>Selecione</MenuItem>
                          {
                            porcentagemStats.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                          }
                        </Select>
                      </FormControl >
                    </Grid>
                  </Grid>
                  <Grid container size={{ xs: 3, sm: 2, md: 2 }} padding={0} display={"flex"} justifyContent={"center"} >
                    <Grid size={12} padding={0} display={"flex"} justifyContent={"center"}>
                      <FormControlLabel
                        key="chkTReb"
                        control={(
                          <Checkbox

                            name="TRebo"
                            checked={chkTReb}
                            onChange={(e) => { carregarDadosMediasJogadores(Number(codigoLiga), temporadaFiltro, tipoFiltro, false, "reb", xTReb, [], false, e.target.checked); setChkTReb(e.target.checked) }}
                            //defaultValue={eval(`telegram${index}`)}
                            disabled={isLoading}
                          />
                        )}
                        label="REB"
                      />
                    </Grid>
                    <Grid size={12} padding={0} display={"flex"} justifyContent={"center"}>
                      <FormControl fullWidth disabled={isLoading || !chkTReb}>
                        <Select
                          variant="outlined"
                          native={false}
                          label="XTReb"
                          value={xTReb}
                          onChange={(e) => { carregarDadosMediasJogadores(Number(codigoLiga), temporadaFiltro, tipoFiltro, false, "reb", Number(e.target.value), [], false, chkTReb); setXTReb(Number(e.target.value)) }}
                        >
                          <MenuItem value={0}>Selecione</MenuItem>
                          {
                            porcentagemStats.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                          }
                        </Select>
                      </FormControl >
                    </Grid>
                  </Grid>
                  <Grid container size={{ xs: 3, sm: 2, md: 2 }} padding={0} display={"flex"} justifyContent={"center"} >
                    <Grid size={12} padding={0} display={"flex"} justifyContent={"center"}>
                      <FormControlLabel
                        key="chkAst"
                        control={(
                          <Checkbox
                            name="AST"
                            checked={chkAst}
                            onChange={(e) => { carregarDadosMediasJogadores(Number(codigoLiga), temporadaFiltro, tipoFiltro, false, "ast", xAst, [], false, e.target.checked); setChkAst(e.target.checked) }}
                            //defaultValue={eval(`telegram${index}`)}
                            disabled={isLoading}
                          />
                        )}
                        label="AST"
                      />
                    </Grid>
                    <Grid size={12} padding={0} display={"flex"} justifyContent={"center"}>
                      <FormControl fullWidth disabled={isLoading || !chkAst}>
                        <Select
                          variant="outlined"
                          native={false}
                          label="XAst"
                          value={xAst}
                          onChange={(e) => { carregarDadosMediasJogadores(Number(codigoLiga), temporadaFiltro, tipoFiltro, false, "ast", Number(e.target.value), [], false, chkAst); setXAst(Number(e.target.value)) }}
                        >
                          <MenuItem value={0}>Selecione</MenuItem>
                          {
                            porcentagemStats.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                          }
                        </Select>
                      </FormControl >
                    </Grid>
                  </Grid>
                  <Grid container size={{ xs: 3, sm: 2, md: 2 }} padding={0} display={"flex"} justifyContent={"center"} >
                    <Grid size={12} padding={0} display={"flex"} justifyContent={"center"}>
                      <FormControlLabel
                        key="chkStl"
                        control={(
                          <Checkbox
                            name="Stl"
                            checked={chkStl}
                            onChange={(e) => { carregarDadosMediasJogadores(Number(codigoLiga), temporadaFiltro, tipoFiltro, false, "stl", xStl, [], false, e.target.checked); setChkStl(e.target.checked) }}
                            //defaultValue={eval(`telegram${index}`)}
                            disabled={isLoading}
                          />
                        )}
                        label="STL"
                      />
                    </Grid>
                    <Grid size={12} padding={0} display={"flex"} justifyContent={"center"}>
                      <FormControl fullWidth disabled={isLoading || !chkStl}>
                        <Select
                          variant="outlined"
                          native={false}
                          label="XStl"
                          value={xStl}
                          onChange={(e) => { carregarDadosMediasJogadores(Number(codigoLiga), temporadaFiltro, tipoFiltro, false, "stl", Number(e.target.value), [], false, chkStl); setXStl(Number(e.target.value)) }}
                        >
                          <MenuItem value={0}>Selecione</MenuItem>
                          {
                            porcentagemStats.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                          }
                        </Select>
                      </FormControl >
                    </Grid>
                  </Grid>
                  <Grid container size={{ xs: 3, sm: 2, md: 2 }} padding={0} display={"flex"} justifyContent={"center"} >
                    <Grid size={12} padding={0} display={"flex"} justifyContent={"center"}>
                      <FormControlLabel
                        key="chkBlk"
                        control={(
                          <Checkbox
                            name="Blk"
                            checked={chkBlk}
                            onChange={(e) => { carregarDadosMediasJogadores(Number(codigoLiga), temporadaFiltro, tipoFiltro, false, "blk", xBlk, [], false, e.target.checked); setChkBlk(e.target.checked) }}
                            //defaultValue={eval(`telegram${index}`)}
                            disabled={isLoading}
                          />
                        )}
                        label="BLK"
                      />
                    </Grid>
                    <Grid size={12} padding={0} display={"flex"} justifyContent={"center"}>
                      <FormControl fullWidth disabled={isLoading || !chkBlk}>
                        <Select
                          variant="outlined"
                          native={false}
                          label="XBlk"
                          value={xBlk}
                          onChange={(e) => { carregarDadosMediasJogadores(Number(codigoLiga), temporadaFiltro, tipoFiltro, false, "blk", Number(e.target.value), [], false, chkBlk); setXBlk(Number(e.target.value)) }}
                        >
                          <MenuItem value={0}>Selecione</MenuItem>
                          {
                            porcentagemStats.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                          }
                        </Select>
                      </FormControl >
                    </Grid>
                  </Grid>
                  <Grid container size={{ xs: 3, sm: 2, md: 2 }} padding={0} display={"flex"} justifyContent={"center"} >
                    <Grid size={12} padding={0} display={"flex"} justifyContent={"center"}>
                      <FormControlLabel
                        key="chkT"
                        control={(
                          <Checkbox
                            name="Turnovers"
                            checked={chkTurnovers}
                            onChange={(e) => { carregarDadosMediasJogadores(Number(codigoLiga), temporadaFiltro, tipoFiltro, false, "to", xTurnovers, [], false, e.target.checked); setChkTurnovers(e.target.checked) }}
                            //defaultValue={eval(`telegram${index}`)}
                            disabled={isLoading}
                          />
                        )}
                        label="TO"
                      />
                    </Grid>
                    <Grid size={12} padding={0} display={"flex"} justifyContent={"center"}>
                      <FormControl fullWidth disabled={isLoading || !chkTurnovers}>
                        <Select
                          variant="outlined"
                          native={false}
                          label="XTurnovers"
                          value={xTurnovers}
                          onChange={(e) => { carregarDadosMediasJogadores(Number(codigoLiga), temporadaFiltro, tipoFiltro, false, "to", Number(e.target.value), [], false, chkTurnovers); setXTurnovers(Number(e.target.value)) }}
                        >
                          <MenuItem value={0}>Selecione</MenuItem>
                          {
                            porcentagemStats.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                          }
                        </Select>
                      </FormControl >
                    </Grid>
                  </Grid>
                  <Grid container size={{ xs: 4, sm: 2, md: 2 }} padding={0} display={"flex"} justifyContent={"center"} >
                    <Grid size={12} padding={0} display={"flex"} justifyContent={"center"}>
                      <FormControlLabel
                        key="chkFaltas"
                        control={(
                          <Checkbox
                            name="Faltas"
                            checked={chkFaltas}
                            onChange={(e) => { carregarDadosMediasJogadores(Number(codigoLiga), temporadaFiltro, tipoFiltro, false, "pf", xFaltas, [], false, e.target.checked); setChkFaltas(e.target.checked) }}
                            //defaultValue={eval(`telegram${index}`)}
                            disabled={isLoading}
                          />
                        )}
                        label="FALTAS"
                      />
                    </Grid>
                    <Grid size={12} padding={0} display={"flex"} justifyContent={"center"}>
                      <FormControl fullWidth disabled={isLoading || !chkFaltas}>
                        <Select
                          variant="outlined"
                          native={false}
                          label="XFaltas"
                          value={xFaltas}
                          onChange={(e) => { carregarDadosMediasJogadores(Number(codigoLiga), temporadaFiltro, tipoFiltro, false, "pf", Number(e.target.value), [], false, chkFaltas); setXFaltas(Number(e.target.value)) }}
                        >
                          <MenuItem value={0}>Selecione</MenuItem>
                          {
                            porcentagemStats.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                          }
                        </Select>
                      </FormControl >
                    </Grid>
                  </Grid>
                  <Grid container size={{ xs: 4, sm: 2, md: 2 }} padding={0} display={"flex"} justifyContent={"center"} >
                    <Grid size={12} padding={0} display={"flex"} justifyContent={"center"}>
                      <FormControlLabel
                        key="chkMinPlus"
                        control={(
                          <Checkbox
                            name="MinPlus"
                            checked={chkMinPlus}
                            onChange={(e) => { carregarDadosMediasJogadores(Number(codigoLiga), temporadaFiltro, tipoFiltro, false, "mplu", xMinPlus, [], false, e.target.checked); setChkMinPlus(e.target.checked) }}
                            //defaultValue={eval(`telegram${index}`)}
                            disabled={isLoading}
                          />
                        )}
                        label="MPLU"
                      />
                    </Grid>
                    <Grid size={12} padding={0} display={"flex"} justifyContent={"center"}>
                      <FormControl fullWidth disabled={isLoading || !chkMinPlus}>
                        <Select
                          variant="outlined"
                          native={false}
                          label="XMinPlus"
                          value={xMinPlus}
                          onChange={(e) => { carregarDadosMediasJogadores(Number(codigoLiga), temporadaFiltro, tipoFiltro, false, "mplu", Number(e.target.value), [], false, chkMinPlus); setXMinPlus(Number(e.target.value)) }}
                        >
                          <MenuItem value={0}>Selecione</MenuItem>
                          {
                            porcentagemStats.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                          }
                        </Select>
                      </FormControl >
                    </Grid>
                  </Grid>
                  <Grid container size={{ xs: 4, sm: 2, md: 2 }} padding={0} display={"flex"} justifyContent={"center"} >
                    <Grid size={12} padding={0} display={"flex"} justifyContent={"center"}>
                      <FormControlLabel
                        key="chkStocks"
                        control={(
                          <Checkbox
                            name="Stocks"
                            checked={chkStocks}
                            onChange={(e) => { carregarDadosMediasJogadores(Number(codigoLiga), temporadaFiltro, tipoFiltro, false, "stocks", xStocks, [], false, e.target.checked); setChkStocks(e.target.checked) }}
                            //defaultValue={eval(`telegram${index}`)}
                            disabled={isLoading}
                          />
                        )}
                        label="STOCKS"
                      />
                    </Grid>
                    <Grid size={12} padding={0} display={"flex"} justifyContent={"center"}>
                      <FormControl fullWidth disabled={isLoading || !chkStocks}>
                        <Select
                          variant="outlined"
                          native={false}
                          label="XStocks"
                          value={xStocks}
                          onChange={(e) => { carregarDadosMediasJogadores(Number(codigoLiga), temporadaFiltro, tipoFiltro, false, "stocks", Number(e.target.value), [], false, chkStocks); setXStocks(Number(e.target.value)) }}
                        >
                          <MenuItem value={0}>Selecione</MenuItem>
                          {
                            porcentagemStats.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                          }
                        </Select>
                      </FormControl >
                    </Grid>
                  </Grid>
                  <Grid container size={{ xs: 3, sm: 2, md: 2 }} padding={0} display={"flex"} justifyContent={"center"} >
                    <Grid size={12} padding={0} display={"flex"} justifyContent={"center"}>
                      <FormControlLabel
                        key="FGA"
                        control={(
                          <Checkbox
                            name="FGA"
                            checked={chkFga}
                            onChange={(e) => { carregarDadosMediasJogadores(Number(codigoLiga), temporadaFiltro, tipoFiltro, false, "fga", xFga, [], false, e.target.checked); setChkFga(e.target.checked) }}
                            //defaultValue={eval(`telegram${index}`)}
                            disabled={isLoading}
                          />
                        )}
                        label="FGA"
                      />
                    </Grid>
                    <Grid size={12} padding={0} display={"flex"} justifyContent={"center"}>
                      <FormControl fullWidth disabled={isLoading || !chkFga}>
                        <Select
                          variant="outlined"
                          native={false}
                          label="XFga"
                          value={xFga}
                          onChange={(e) => { carregarDadosMediasJogadores(Number(codigoLiga), temporadaFiltro, tipoFiltro, false, "fga", Number(e.target.value), [], false, chkFga); setXFga(Number(e.target.value)) }}
                        >
                          <MenuItem value={0}>Selecione</MenuItem>
                          {
                            porcentagemStats.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                          }
                        </Select>
                      </FormControl >
                    </Grid>
                  </Grid>
                  <Grid container size={{ xs: 3, sm: 2, md: 2 }} padding={0} display={"flex"} justifyContent={"center"} >
                    <Grid size={12} padding={0} display={"flex"} justifyContent={"center"}>
                      <FormControlLabel
                        key="FGE"
                        control={(
                          <Checkbox
                            name="FGE"
                            checked={chkFge}
                            onChange={(e) => { carregarDadosMediasJogadores(Number(codigoLiga), temporadaFiltro, tipoFiltro, false, "fge", xFge, [], false, e.target.checked); setChkFge(e.target.checked) }}
                            //defaultValue={eval(`telegram${index}`)}
                            disabled={isLoading}
                          />
                        )}
                        label="FGE"
                      />
                    </Grid>
                    <Grid size={12} padding={0} display={"flex"} justifyContent={"center"}>
                      <FormControl fullWidth disabled={isLoading || !chkFge}>
                        <Select
                          variant="outlined"
                          native={false}
                          label="XFge"
                          value={xFge}
                          onChange={(e) => { carregarDadosMediasJogadores(Number(codigoLiga), temporadaFiltro, tipoFiltro, false, "fge", Number(e.target.value), [], false, chkFge); setXFge(Number(e.target.value)) }}
                        >
                          <MenuItem value={0}>Selecione</MenuItem>
                          {
                            porcentagemStats.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                          }
                        </Select>
                      </FormControl >
                    </Grid>
                  </Grid>
                  <Grid container size={{ xs: 3, sm: 2, md: 2 }} padding={0} display={"flex"} justifyContent={"center"} >
                    <Grid size={12} padding={0} display={"flex"} justifyContent={"center"}>
                      <FormControlLabel
                        key="FTE"
                        control={(
                          <Checkbox
                            name="FTE"
                            checked={chkFte}
                            onChange={(e) => { carregarDadosMediasJogadores(Number(codigoLiga), temporadaFiltro, tipoFiltro, false, "fte", xFte, [], false, e.target.checked); setChkFte(e.target.checked) }}
                            //defaultValue={eval(`telegram${index}`)}
                            disabled={isLoading}
                          />
                        )}
                        label="FTE"
                      />
                    </Grid>
                    <Grid size={12} padding={0} display={"flex"} justifyContent={"center"}>
                      <FormControl fullWidth disabled={isLoading || !chkFte}>
                        <Select
                          variant="outlined"
                          native={false}
                          label="XFte"
                          value={xFte}
                          onChange={(e) => { carregarDadosMediasJogadores(Number(codigoLiga), temporadaFiltro, tipoFiltro, false, "fte", Number(e.target.value), [], false, chkFte); setXFte(Number(e.target.value)) }}
                        >
                          <MenuItem value={0}>Selecione</MenuItem>
                          {
                            porcentagemStats.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                          }
                        </Select>
                      </FormControl >
                    </Grid>
                  </Grid>
                  <Grid container size={{ xs: 3, sm: 2, md: 2 }} padding={0} display={"flex"} justifyContent={"center"} >
                    <Grid size={12} padding={0} display={"flex"} justifyContent={"center"}>
                      <FormControlLabel
                        key="FTA"
                        control={(
                          <Checkbox

                            name="FTA"
                            checked={chkFta}
                            onChange={(e) => { carregarDadosMediasJogadores(Number(codigoLiga), temporadaFiltro, tipoFiltro, false, "fta", xFta, [], false, e.target.checked); setChkFta(e.target.checked) }}
                            //defaultValue={eval(`telegram${index}`)}
                            disabled={isLoading}
                          />
                        )}
                        label="FTA"
                      />
                    </Grid>
                    <Grid size={12} padding={0} display={"flex"} justifyContent={"center"}>
                      <FormControl fullWidth disabled={isLoading || !chkFta}>
                        <Select
                          variant="outlined"
                          native={false}
                          label="XFta"
                          value={xFta}
                          onChange={(e) => { carregarDadosMediasJogadores(Number(codigoLiga), temporadaFiltro, tipoFiltro, false, "fta", Number(e.target.value), [], false, chkFta); setXFta(Number(e.target.value)) }}
                        >
                          <MenuItem value={0}>Selecione</MenuItem>
                          {
                            porcentagemStats.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                          }
                        </Select>
                      </FormControl >
                    </Grid>
                  </Grid>
                  <Grid container size={{ xs: 3, sm: 2, md: 2 }} padding={0} display={"flex"} justifyContent={"center"} >
                    <Grid size={12} padding={0} display={"flex"} justifyContent={"center"}>
                      <FormControlLabel
                        key="FGMP"
                        control={(
                          <Checkbox
                            name="FGMP"
                            checked={chkFgmp}
                            onChange={(e) => { carregarDadosMediasJogadores(Number(codigoLiga), temporadaFiltro, tipoFiltro, false, "fgmp", xFgmp, [], false, e.target.checked); setChkFgmp(e.target.checked) }}
                            //defaultValue={eval(`telegram${index}`)}
                            disabled={isLoading}
                          />
                        )}
                        label="FGMP"
                      />
                    </Grid>
                    <Grid size={12} padding={0} display={"flex"} justifyContent={"center"}>
                      <FormControl fullWidth disabled={isLoading || !chkFgmp}>
                        <Select
                          variant="outlined"
                          native={false}
                          label="XFgmp"
                          value={xFgmp}
                          onChange={(e) => { carregarDadosMediasJogadores(Number(codigoLiga), temporadaFiltro, tipoFiltro, false, "fgmp", Number(e.target.value), [], false, chkFgmp); setXFgmp(Number(e.target.value)) }}
                        >
                          <MenuItem value={0}>Selecione</MenuItem>
                          {
                            porcentagemStats.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                          }
                        </Select>
                      </FormControl >
                    </Grid>
                  </Grid>
                  <Grid container size={{ xs: 3, sm: 2, md: 2 }} padding={0} display={"flex"} justifyContent={"center"} >
                    <Grid size={12} padding={0} display={"flex"} justifyContent={"center"}>
                      <FormControlLabel
                        key="FTMP"
                        control={(
                          <Checkbox
                            name="FTMP"
                            checked={chkFtmp}
                            onChange={(e) => { carregarDadosMediasJogadores(Number(codigoLiga), temporadaFiltro, tipoFiltro, false, "ftmp", xFtmp, [], false, e.target.checked); setChkFtmp(e.target.checked) }}
                            //defaultValue={eval(`telegram${index}`)}
                            disabled={isLoading}
                          />
                        )}
                        label="FTMP"
                      />
                    </Grid>
                    <Grid size={12} padding={0} display={"flex"} justifyContent={"center"}>
                      <FormControl fullWidth disabled={isLoading || !chkFtmp}>
                        <Select
                          variant="outlined"
                          native={false}
                          label="XFtmp"
                          value={xFtmp}
                          onChange={(e) => { carregarDadosMediasJogadores(Number(codigoLiga), temporadaFiltro, tipoFiltro, false, "ftmp", Number(e.target.value), [], false, chkFtmp); setXFtmp(Number(e.target.value)) }}
                        >
                          <MenuItem value={0}>Selecione</MenuItem>
                          {
                            porcentagemStats.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                          }
                        </Select>
                      </FormControl >
                    </Grid>
                  </Grid>
                  <Grid container size={{ xs: 3, sm: 2, md: 2 }} padding={0} display={"flex"} justifyContent={"center"} >
                    <Grid size={12} padding={0} display={"flex"} justifyContent={"center"}>
                      <FormControlLabel
                        key="3pa"
                        control={(
                          <Checkbox
                            name="3pa"
                            checked={chk3pa}
                            onChange={(e) => { carregarDadosMediasJogadores(Number(codigoLiga), temporadaFiltro, tipoFiltro, false, "threepa", x3pa, [], false, e.target.checked); setChk3pa(e.target.checked) }}
                            //defaultValue={eval(`telegram${index}`)}
                            disabled={isLoading}
                          />
                        )}

                        label="3PA"
                      />
                    </Grid>
                    <Grid size={12} padding={0} display={"flex"} justifyContent={"center"}>
                      <FormControl fullWidth disabled={isLoading || !chk3pa}>
                        <Select
                          variant="outlined"
                          native={false}
                          label="X3pa"
                          value={x3pa}
                          onChange={(e) => { carregarDadosMediasJogadores(Number(codigoLiga), temporadaFiltro, tipoFiltro, false, "threepa", Number(e.target.value), [], false, chk3pa); setX3pa(Number(e.target.value)) }}
                        >
                          <MenuItem value={0}>Selecione</MenuItem>
                          {
                            porcentagemStats.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                          }
                        </Select>
                      </FormControl >
                    </Grid>
                  </Grid>
                  <Grid container size={{ xs: 3, sm: 2, md: 2 }} padding={0} display={"flex"} justifyContent={"center"} >
                    <Grid size={12} padding={0} display={"flex"} justifyContent={"center"}>
                      <FormControlLabel
                        key="3pe"
                        control={(
                          <Checkbox
                            name="3pe"
                            checked={chk3pe}
                            onChange={(e) => { carregarDadosMediasJogadores(Number(codigoLiga), temporadaFiltro, tipoFiltro, false, "threepe", x3pe, [], false, e.target.checked); setChk3pe(e.target.checked) }}
                            //defaultValue={eval(`telegram${index}`)}
                            disabled={isLoading}
                          />
                        )}

                        label="3PE"
                      />
                    </Grid>
                    <Grid size={12} padding={0} display={"flex"} justifyContent={"center"}>
                      <FormControl fullWidth disabled={isLoading || !chk3pe}>
                        <Select
                          variant="outlined"
                          native={false}
                          label="X3pe"
                          value={x3pe}
                          onChange={(e) => { carregarDadosMediasJogadores(Number(codigoLiga), temporadaFiltro, tipoFiltro, false, "threepe", Number(e.target.value), [], false, chk3pe); setX3pe(Number(e.target.value)) }}
                        >
                          <MenuItem value={0}>Selecione</MenuItem>
                          {
                            porcentagemStats.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                          }
                        </Select>
                      </FormControl >
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid size={{ xs: 12 }}>
                <hr />
              </Grid>
              <Grid size={{ xs: 12, sm: 12 }}>
                {isLoading && !removeLoading && <Loading />}
              </Grid>
              <Grid size={{ xs: 12, sm: 12 }}  >
                {estatisticasRows.length > 0 && (
                  <Box
                    sx={{
                      height: 'auto', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto", fontWeight: 'bold',
                      '& .super-app-theme--header': {
                        backgroundColor: theme.palette.common.black,
                        color: theme.palette.common.white,
                      },
                      '& .super-app.negative': {
                        color: 'red',
                        fontWeight: 'bold'
                      },
                      '& .super-app.positive': {
                        //color: "#00e676", /// themeName === "light" ? "black" : "auto",
                        fontWeight: '600',
                      },
                      '& .super-app-theme--cell': {
                        color: '#00e676',
                        fontWeight: 'bold'
                      },
                      "& .MuiDataGrid-cell": {
                        fontWeight: 'bold'
                      },
                      '& .MuiDataGrid-main': {
                        height: UtilidadeService.isMobile() ? "380px" : "maxValor",
                        overflow: UtilidadeService.isMobile() ? "overlay" : "hidden",
                      },
                      '& .MuiDataGrid-columnHeaders ': {
                        //position: UtilidadeService.isMobile() ? "fixed" : "relative",
                        zIndex: UtilidadeService.isMobile() ? 999 : "auto",
                      }
                    }}>
                    <DataGrid
                      localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                      getRowId={(r) => r.codigo}
                      rows={estatisticasRows}
                      columns={columnsGeral}
                      initialState={{
                        pagination: {
                          paginationModel: {
                            pageSize: 16,
                          },
                        },
                      }}
                      columnVisibilityModel={{
                        codigo: false,
                        ast: chkAst, // estatisticasRows.filter(f => f.ast === null).length === 0,
                        blk: chkBlk, // estatisticasRows.filter(f => (f.blk === null)).length === 0,
                        dreb: chkDReb, // estatisticasRows.filter(f => (f.dreb === null)).length === 0,
                        fga: chkFga, // estatisticasRows.filter(f => (f.fga === null)).length === 0,
                        fgm: chkFgm, // estatisticasRows.filter(f => f.fgm === null).length === 0,
                        fgmp: chkFgmp, // estatisticasRows.filter(f => (f.fgmp === null)).length === 0,
                        fta: chkFta, // estatisticasRows.filter(f => (f.fta === null)).length === 0,
                        ftm: chkFtm, // estatisticasRows.filter(f => (f.ftm === null)).length === 0,
                        ftmp: chkFtmp, // estatisticasRows.filter(f => (f.ftmp === null)).length === 0,
                        //min: estatisticasRows.filter(f => (f.min === null)).length === 0,
                        mplu: chkMinPlus,// estatisticasRows.filter(f => (f.mplu === null)).length === 0,
                        oreb: chkOReb, // estatisticasRows.filter(f => (f.oreb === null)).length === 0,
                        pf: chkFaltas, // estatisticasRows.filter(f => (f.pf === null)).length === 0,
                        pts: chkPts, // estatisticasRows.filter(f => (f.pts === null)).length === 0,
                        reb: chkTReb, // estatisticasRows.filter(f => (f.reb === null)).length === 0,
                        stl: chkStl, // estatisticasRows.filter(f => (f.stl === null)).length === 0,
                        threepa: chk3pa, // estatisticasRows.filter(f => (f.threepa === null)).length === 0,
                        threepm: chk3pm, // estatisticasRows.filter(f => (f.threepm === null)).length === 0,
                        threepmp: chk3pmp, // estatisticasRows.filter(f => (f.threepmp === null)).length === 0,
                        to: chkTurnovers, // estatisticasRows.filter(f => (f.to === null)).length === 0,
                        fge: chkFge, // estatisticasRows.filter(f => (f.fge === null || f.fge === undefined)).length === 0,
                        fte: chkFte, // estatisticasRows.filter(f => (f.fte === null || f.fte === undefined)).length === 0,
                        threepe: chk3pe, // estatisticasRows.filter(f => (f.threepe === null || f.threepe === undefined)).length === 0,
                        stocks: chkStocks, // estatisticasRows.filter(f => (f.stocks === null || f.stocks === undefined)).length === 0,
                        peso_Minutos_Jogador: estatisticasRows.filter(f => f.peso_Minutos_Jogador === null).length === 0,
                      }}
                      pageSizeOptions={[16, 25, 50, 100]}
                      disableRowSelectionOnClick
                      disableColumnMenu
                      sx={{
                        fontSize: UtilidadeService.isMobile() ? 11 : 16,
                      }}
                    />
                  </Box>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </LayoutBaseDePagina >
  )
}

